/**
 * Impulse テーマの vendor theme.js への上書き（商品サムネ Flickity / 一覧切替 / カウンタなど）
 * theme.js のアップデート時は本ファイルのみ再適用すればよい。
 *
 * @version 1.2.1
 * @updated 2026-10-01
 *
 * 枚数はギャラリー順の何枚目か（data-index + 1）。初回メインは Liquid で
 * product.media 先頭を starting-slide にしているため、ロード時は 1 / N になる。
 *
 * Changelog:
 * - 1.2.1: 価格帯切替で旧 price パラメータが残る不具合を修正
 * - 1.2.0: 価格フィルター帯（data-price-band）選択時に min/max を同期
 * - 1.1.0: 既存カスタム（サムネ / タブ / sticky cart 等）
 */
(function () {
  'use strict';

  if (!window.theme || !theme.Slideshow || !theme.Product) {
    return;
  }

  var LOG_PREFIX = '[theme-custom:thumb]';

  // Debug logging removed.
  function thumbDebug() {}
  function slideDebug() {}

  function thumbError(scope, err) {
    if (!window.console || !console.error) {
      return;
    }
    var msg = err && err.message ? err.message : String(err);
    var stack = err && err.stack ? err.stack : '(no stack)';
    console.error(LOG_PREFIX, scope, msg, '\n', stack);
  }

  var THUMB_ACTIVE_CLASS = 'is-active';

  /**
   * false: 一覧/スライダー状態を localStorage に保存・復元しない（初回 Flickity 不具合の切り分け用）。
   * 元に戻すときは true にする。
   */
  var USE_THUMB_VIEW_LOCAL_STORAGE = false;

  var productSliderSelectors = {
    slide: '.product-main-slide',
    startingSlide: '.starting-slide',
  };

  Object.assign(theme.Slideshow.prototype, {
    /**
     * メイン Flickity wrapAround 時、change の index / selectedIndex はセル配列用で
     * サムネの data-index（0..n-1）と一致しないことがある。.product-main-slide の data-index に合わせる。
     */
    getLogicalProductSlideIndex: function (cellIndexHint) {
      if (!this.slideshow || !this.slideshow.cells || !this.slideshow.cells.length) {
        return typeof cellIndexHint === 'number' ? cellIndexHint : 0;
      }
      var ci =
        typeof cellIndexHint === 'number' &&
        cellIndexHint >= 0 &&
        cellIndexHint < this.slideshow.cells.length
          ? cellIndexHint
          : this.slideshow.selectedIndex;
      if (typeof ci !== 'number' || ci < 0 || ci >= this.slideshow.cells.length) {
        return 0;
      }
      var cell = this.slideshow.cells[ci];
      if (!cell || !cell.element) {
        return 0;
      }
      var node = cell.element;
      var slide =
        node.classList && node.classList.contains('product-main-slide')
          ? node
          : node.querySelector
            ? node.querySelector('.product-main-slide')
            : null;
      if (!slide && node.closest) {
        slide = node.closest('.product-main-slide');
      }
      if (!slide) {
        return typeof cellIndexHint === 'number' ? cellIndexHint : ci;
      }
      var di = slide.getAttribute('data-index');
      if (di == null || di === '') {
        return typeof cellIndexHint === 'number' ? cellIndexHint : ci;
      }
      var n = parseInt(di, 10);
      return isNaN(n) ? 0 : n;
    },

    childNavGoTo: function (index) {
      var idx = this.getLogicalProductSlideIndex(typeof index === 'number' ? index : undefined);
      this.childNavLinks.forEach(function (a) {
        a.blur();
        a.classList.remove(THUMB_ACTIVE_CLASS);
      });

      // initChildNav が各 a の data-index を「表示順 0..」に上書きするため、
      // メインの論理インデックス（メディア順）と childNavLinks[idx] は一致しない。
      // Liquid のまま残る .product__thumb-item[data-index]（または data-id）で解決する。
      var nav = this.args.childNav;
      var el = null;
      if (nav && nav.querySelector) {
        var itemByIdx = nav.querySelector(
          '.product__thumb-item:not([data-in-current-set="false"])[data-index="' + idx + '"]'
        );
        if (itemByIdx) {
          el =
            itemByIdx.querySelector('a[data-product-thumb]') ||
            itemByIdx.querySelector('a');
        }
      }
      if (!el && nav && nav.querySelector && this.slideshow && this.slideshow.cells) {
        var ci =
          typeof index === 'number' &&
          index >= 0 &&
          index < this.slideshow.cells.length
            ? index
            : this.slideshow.selectedIndex;
        var cell = this.slideshow.cells[ci];
        var slide =
          cell &&
          cell.element &&
          (cell.element.classList && cell.element.classList.contains('product-main-slide')
            ? cell.element
            : cell.element.querySelector
              ? cell.element.querySelector('.product-main-slide')
              : null);
        var mid = slide && slide.getAttribute ? slide.getAttribute('data-media-id') : null;
        if (mid) {
          el = nav.querySelector(
            '.product__thumb-item:not([data-in-current-set="false"]) a[data-product-thumb][data-id="' +
              mid +
              '"]'
          );
        }
      }
      if (!el) {
        el = this.childNavLinks[idx];
      }
      if (!el) {
        return;
      }
      el.classList.add(THUMB_ACTIVE_CLASS);

      var viewMode = this.args.getThumbViewMode ? this.args.getThumbViewMode() : 'slider';

      if (viewMode === 'list') {
        try {
          if (typeof el.scrollIntoView === 'function') {
            el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        } catch (e) {}
        return;
      }

      // 下段サムネ strip（Flickity）の表示位置は、メインの settle 後に Product 側で合わせる。
      // ここでは is-active のみ（theme.Slideshow の change / settle 双方で呼ばれる）。
      if (
        nav &&
        nav.getAttribute &&
        nav.getAttribute('data-thumb-strip-flickity') === 'true'
      ) {
        return;
      }

      var thumbFlk = this.args.thumbFlickityGetter ? this.args.thumbFlickityGetter() : null;
      if (thumbFlk && typeof thumbFlk.select === 'function') {
        var thumbWrap = el.closest('.product__thumb-item');
        var linkEl = el;
        var targetThumbId = linkEl && linkEl.dataset ? linkEl.dataset.id : null;
        var targetCi = -1;
        if (thumbWrap && thumbFlk.cells) {
          for (var ci = 0; ci < thumbFlk.cells.length; ci++) {
            var cel = thumbFlk.cells[ci].element;
            if (!cel) {
              continue;
            }
            if (cel === thumbWrap || (linkEl && typeof cel.contains === 'function' && cel.contains(linkEl))) {
              targetCi = ci;
              break;
            }
          }
        }
        if (targetCi < 0 && targetThumbId && thumbFlk.cells) {
          for (var ck = 0; ck < thumbFlk.cells.length; ck++) {
            var celk = thumbFlk.cells[ck].element;
            if (!celk) continue;
            var match =
              celk.querySelector &&
              celk.querySelector('[data-product-thumb][data-id="' + targetThumbId + '"]');
            if (match) {
              targetCi = ck;
              break;
            }
          }
        }
        if (targetCi < 0 && thumbFlk.cells) {
          for (var cj = 0; cj < thumbFlk.cells.length; cj++) {
            var cel2 = thumbFlk.cells[cj].element;
            if (!cel2) {
              continue;
            }
            var di = cel2.getAttribute('data-index');
            if (di !== null && parseInt(di, 10) === idx) {
              targetCi = cj;
              break;
            }
          }
        }
        if (targetCi >= 0) {
          var cellEl = thumbFlk.cells[targetCi].element;
          if (typeof thumbFlk.selectCell === 'function' && cellEl) {
            // メインの change が連続するため、サムネ strip は即時選択の方が追従が確実
            thumbFlk.selectCell(cellEl, false, true);
          } else {
            thumbFlk.select(targetCi, false, true);
          }
        } else if (thumbWrap && typeof thumbFlk.selectCell === 'function') {
          try {
            thumbFlk.selectCell(thumbWrap, false, true);
          } catch (e) {
            thumbError('childNavGoTo selectCell(thumbWrap)', e);
          }
        }
        if (typeof thumbFlk.reposition === 'function') {
          thumbFlk.reposition();
        }
        return;
      }

      if (!this.args.childNavScroller) {
        return;
      }

      if (this.args.childVertical) {
        var elTop = el.offsetTop;
        this.args.childNavScroller.scrollTop = elTop - 100;
      } else {
        var elLeft = el.offsetLeft;
        this.args.childNavScroller.scrollLeft = elLeft - 100;
      }
    },

    syncChildNav: function (index) {
      if (!this.args.childNav || !this.childNavLinks || !this.childNavLinks.length) {
        return;
      }
      if (typeof index === 'undefined' || index === null) {
        return;
      }
      this.childNavGoTo(index);
    },
  });

  // Ensure our overridden updateVariantImage is the one bound to variantImageChange.
  // Depending on script load order, the product instance may have already bound
  // the original handler; rebinding in initVariants guarantees sync behavior.
  var _origProductInitVariants = theme.Product && theme.Product.prototype && theme.Product.prototype.initVariants;
  var _origProductInit = theme.Product && theme.Product.prototype && theme.Product.prototype.init;
  var _origUpdateImageSetThumbs = theme.Product.prototype.updateImageSetThumbs;

  Object.assign(theme.Product.prototype, {
    updateImageSetThumbs: function (set) {
      if (typeof _origUpdateImageSetThumbs === 'function') {
        _origUpdateImageSetThumbs.call(this, set);
      }
      try {
        var flk = this.getThumbFlickity && this.getThumbFlickity();
        if (flk && typeof flk.reloadCells === 'function') {
          flk.reloadCells();
        }
        if (flk && typeof flk.reposition === 'function') {
          flk.reposition();
        }
      } catch (e) {
        thumbError('updateImageSetThumbs reloadCells', e);
      }
    },

    _getVariantEventTargets: function () {
      var targets = [];
      if (this.container) {
        targets.push(this.container);
        if (this.container.closest) {
          var section = this.container.closest('.product-section');
          if (section && section !== this.container) {
            targets.push(section);
          }
        }
      }
      return targets;
    },

    _bindVariantEventsForThumbSyncOnce: function () {
      if (this._thumbVariantSyncBound) {
        return;
      }
      if (!this.container) {
        return;
      }
      this._thumbVariantSyncBound = true;

      try {
        var targets = this._getVariantEventTargets();

        this._variantImageChangeHandler = function (evt) {
          try {
            this.updateVariantImage(evt);
          } catch (e) {
            thumbError('variantImageChange > updateVariantImage', e);
          }
        }.bind(this);

        targets.forEach(function (t) {
          t.addEventListener('variantImageChange', this._variantImageChangeHandler);
        }, this);
      } catch (e) {
        thumbError('_bindVariantEventsForThumbSyncOnce', e);
      }
    },

    init: function () {
      if (typeof _origProductInit === 'function') {
        _origProductInit.call(this);
      }

      // Bind once per product instance, after core init has run.
      this._bindVariantEventsForThumbSyncOnce();
    },

    initVariants: function () {
      if (typeof _origProductInitVariants === 'function') {
        _origProductInitVariants.call(this);
      }

      if (!this.container || !this.settings || !this.settings.namespace) {
        return;
      }

      // Ensure variant events are bound even if init order was unusual.
      this._bindVariantEventsForThumbSyncOnce();
    },

    updateVariantImage: function (evt) {
      // Already handled by updateImageSet when there are image sets
      if (this.settings && this.settings.imageSetName) return;

      var variant = evt && evt.detail ? evt.detail.variant : null;
      if (!variant || !variant.featured_media || !variant.featured_media.id) {
        return;
      }

      // 下段 strip（thumbStripFlickity）は flickity-as-nav-for でメインの select に追従する。
      // スクロール型サムネのみ従来どおり syncChildNav / selectCell を使う。
      var mediaId = String(variant.featured_media.id);
      var thumbLinkInStrip =
        (this.cache && this.cache.thumbSlider) ?
          this.cache.thumbSlider.querySelector('.js-product-thumbs-flickity [data-product-thumb][data-id="' + mediaId + '"]') :
          null;
      var thumbLinkFallback = this.container.querySelector('.product__thumb[data-id="' + mediaId + '"]');
      var thumbLink = thumbLinkInStrip || thumbLinkFallback;
      if (!thumbLink) return;
      var imageIndex = thumbLink.dataset.index;

      // Main slider
      if (this.flickity) {
        // theme.Slideshow.goToSlide supports mediaId or index. Prefer mediaId for correctness.
        this.flickity.goToSlide(mediaId);
      }

      // Thumb strip (Flickity) or legacy scroller
      requestAnimationFrame(function () {
        try {
          this.ensureThumbStripFlickityIfNeeded();
        } catch (e) {
          thumbError('updateVariantImage > ensureThumbStripFlickityIfNeeded', e);
        }

        // When using thumb strip Flickity, data-index may not match Flickity cell index.
        // Select the actual thumb cell for the variant media id.
        if (this.getThumbViewMode() === 'slider') {
          var stripAsNav =
            this.cache.thumbSlider && this.cache.thumbSlider.dataset.thumbStripFlickity === 'true';
          if (!stripAsNav) {
            try {
              var thumbFlkVar = this.getThumbFlickity();
              var thumbCell = thumbLinkInStrip ? thumbLinkInStrip.closest('.product__thumb-item') : null;
              if (!thumbCell) {
                thumbCell = null;
              }
              if (thumbFlkVar && thumbCell && typeof thumbFlkVar.selectCell === 'function') {
                thumbFlkVar.selectCell(thumbCell, false, true);
                return;
              }
            } catch (e) {
              thumbError('updateVariantImage > thumbFlickity.selectCell', e);
            }
          }
        }

        if (this.flickity && typeof this.flickity.syncChildNav === 'function') {
          var idx = typeof imageIndex !== 'undefined' ? parseInt(imageIndex) : 0;
          this.flickity.syncChildNav(idx);
        }
      }.bind(this));
    },

    destroyThumbFlickity: function () {
      if (this.thumbFlickity && typeof this.thumbFlickity.destroy === 'function') {
        this.thumbFlickity.destroy();
      }
      this.thumbFlickity = null;
    },

    getThumbViewMode: function () {
      var el = this.cache.thumbSlider;
      if (!el) {
        return 'slider';
      }
      return el.dataset.viewMode === 'list' ? 'list' : 'slider';
    },

    /** サムネ strip Flickity（this.thumbFlickity 喪失時は Flickity.data で復元） */
    getThumbFlickity: function () {
      if (this.thumbFlickity) {
        return this.thumbFlickity;
      }
      var root = this.cache && this.cache.thumbSlider;
      if (!root || root.dataset.thumbStripFlickity !== 'true') {
        return null;
      }
      if (this.getThumbViewMode() === 'list') {
        return null;
      }
      var container = root.querySelector('.js-product-thumbs-flickity');
      if (!container || !window.Flickity) {
        return null;
      }
      if (typeof window.Flickity.data === 'function') {
        var existing = window.Flickity.data(container);
        if (existing) {
          this.thumbFlickity = existing;
          return existing;
        }
      }
      if (container.classList.contains('flickity-enabled')) {
        try {
          if (typeof window.Flickity.data === 'function') {
            var stale = window.Flickity.data(container);
            if (stale && typeof stale.destroy === 'function') {
              stale.destroy();
            }
          }
        } catch (e) {
          thumbError('getThumbFlickity stale destroy', e);
        }
      }
      try {
        this.initThumbStripFlickity();
      } catch (e) {
        thumbError('getThumbFlickity > initThumbStripFlickity', e);
      }
      return this.thumbFlickity || null;
    },

    initThumbStripFlickity: function () {
      var root = this.cache.thumbSlider;
      if (!root || root.dataset.thumbStripFlickity !== 'true') {
        return;
      }
      if (this.getThumbViewMode() === 'list') {
        return;
      }
      var container = root.querySelector('.js-product-thumbs-flickity');
      if (!container || !window.Flickity || typeof window.Flickity !== 'function') {
        return;
      }
      if (container.classList.contains('flickity-enabled')) {
        if (typeof window.Flickity.data === 'function') {
          var recovered = window.Flickity.data(container);
          if (recovered) {
            this.thumbFlickity = recovered;
            return;
          }
        }
        try {
          if (typeof window.Flickity.data === 'function') {
            var staleInit = window.Flickity.data(container);
            if (staleInit && typeof staleInit.destroy === 'function') {
              staleInit.destroy();
            }
          }
        } catch (e) {
          thumbError('initThumbStripFlickity stale destroy', e);
        }
        if (container.classList.contains('flickity-enabled')) {
          container.classList.remove('flickity-enabled');
        }
      }
      var optsText = container.getAttribute('data-flickity-options') || '{}';
      var opts;
      try {
        opts = JSON.parse(optsText);
      } catch (e) {
        thumbError('initThumbStripFlickity JSON.parse(data-flickity-options)', e);
        opts = {};
      }
      opts.rightToLeft = theme.config.rtl;
      opts.cellSelector = '.product__thumb-item[data-in-current-set="true"]';
      if (this.flickity && this.flickity.slideshow && this.cache.mainSlider) {
        opts.asNavFor = this.cache.mainSlider;
      }
      try {
        this.thumbFlickity = new window.Flickity(container, opts);
      } catch (e) {
        thumbError('initThumbStripFlickity new Flickity()', e);
        throw e;
      }
      try {
        this.bindThumbFlickityDragClickFix();
      } catch (e) {
        thumbError('initThumbStripFlickity bindThumbFlickityDragClickFix', e);
        throw e;
      }

      // 初回表示で viewport 高さが極小になるケースがあるため、強制再計測する。
      //（画像読み込み・フォント・AOS などのレイアウト確定前に init されると起きやすい）
      try {
        var flk = this.thumbFlickity;
        if (flk && typeof flk.resize === 'function') {
          flk.resize();
        }
        if (flk && typeof flk.reposition === 'function') {
          flk.reposition();
        }
        if (flk && typeof flk.on === 'function') {
          flk.on('settle', function () {
            if (typeof flk.resize === 'function') flk.resize();
            if (typeof flk.reposition === 'function') flk.reposition();
          });
        }
        window.requestAnimationFrame(function () {
          if (flk && typeof flk.resize === 'function') flk.resize();
          if (flk && typeof flk.reposition === 'function') flk.reposition();
        });
        window.setTimeout(function () {
          if (flk && typeof flk.resize === 'function') flk.resize();
          if (flk && typeof flk.reposition === 'function') flk.reposition();
        }, 250);
      } catch (e) {
        thumbError('initThumbStripFlickity post-init resize/reposition', e);
      }
    },

    /**
     * メイン Slideshow 初期化や content-visibility / ホットリロードのあと、
     * サムネ strip に flickity-enabled が付いていなければ再初期化する。
     */
    ensureThumbStripFlickityIfNeeded: function () {
      if (!this.cache.thumbSlider || this.cache.thumbSlider.dataset.thumbStripFlickity !== 'true') {
        return;
      }
      if (this.getThumbViewMode() === 'list') {
        return;
      }
      if (this.getThumbFlickity()) {
        return;
      }
      var container = this.cache.thumbSlider.querySelector('.js-product-thumbs-flickity');
      if (!container || !window.Flickity || typeof window.Flickity !== 'function') {
        return;
      }
      if (container.classList.contains('flickity-enabled')) {
        try {
          if (typeof window.Flickity.data === 'function') {
            var stale = window.Flickity.data(container);
            if (stale && typeof stale.destroy === 'function') {
              stale.destroy();
            }
          }
        } catch (e) {
          thumbError('ensureThumbStripFlickityIfNeeded stale destroy', e);
        }
      }
      this.initThumbStripFlickity();
    },

    bindThumbFlickityDragClickFix: function () {
      var root = this.cache.thumbSlider;
      var flk = this.thumbFlickity;
      if (!root || !flk) {
        return;
      }
      var self = this;

      if (!root.dataset.thumbFlickityDragFixBound) {
        root.dataset.thumbFlickityDragFixBound = 'true';
        root.addEventListener(
          'click',
          function (e) {
            var link = e.target.closest('[data-product-thumb]');
            if (!link || !root.contains(link)) {
              return;
            }
            if (self.suppressThumbLinkClickAfterDrag) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
            }
          },
          true
        );
      }

      flk.on('dragStart', function () {
        self.suppressThumbLinkClickAfterDrag = true;
      });
      flk.on('dragEnd', function () {
        window.setTimeout(function () {
          self.suppressThumbLinkClickAfterDrag = false;
        }, 120);
      });
    },

    applyThumbViewFromStorageOnce: function () {
      if (!USE_THUMB_VIEW_LOCAL_STORAGE) {
        return;
      }
      if (this.thumbViewStorageApplied || !theme.config.hasLocalStorage) {
        return;
      }
      var root = this.cache.thumbSlider;
      if (!root || !root.querySelector('[data-thumb-view-toggle]') || !root.dataset.productId) {
        return;
      }
      var saved = window.localStorage.getItem('product-thumb-view-' + root.dataset.productId);
      if (saved !== 'list' && saved !== 'slider') {
        return;
      }
      this.thumbViewStorageApplied = true;
      root.dataset.viewMode = saved;
      root.classList.toggle('product__thumbs--view-list', saved === 'list');
      this.updateThumbViewToggleButtons(root);
    },

    updateThumbViewToggleButtons: function (root) {
      if (!root) {
        return;
      }
      var mode = root.dataset.viewMode === 'list' ? 'list' : 'slider';
      root.querySelectorAll('[data-thumb-view-toggle]').forEach(function (btn) {
        var m = btn.getAttribute('data-thumb-view-toggle');
        var active = m === mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    },

    scrollMainMediaIntoViewInstant: function () {
      var mainEl = this.cache.mainSlider && this.cache.mainSlider.closest('[data-product-single-media-group]');
      if (!mainEl) {
        mainEl = this.container.querySelector('[data-product-single-media-group]');
      }
      if (!mainEl) {
        mainEl = this.cache.mainSlider && this.cache.mainSlider.closest('.product__main-photos');
      }
      if (!mainEl) {
        return;
      }
      var html = document.documentElement;
      var body = document.body;
      var prevHtml = html.style.scrollBehavior;
      var prevBody = body.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      body.style.scrollBehavior = 'auto';
      try {
        mainEl.scrollIntoView({ behavior: 'instant', block: 'start' });
      } catch (e) {
        try {
          mainEl.scrollIntoView({ block: 'start' });
        } catch (e2) {}
      } finally {
        html.style.scrollBehavior = prevHtml;
        body.style.scrollBehavior = prevBody;
      }
    },

    /** モバイル: 一覧／スライダーどちらのサムネでも、選択時にメインメディア先頭までスクロール */
    initListThumbJumpToMainOnce: function () {
      if (this.listThumbJumpBound) {
        return;
      }
      this.listThumbJumpBound = true;
      var self = this;
      function onThumbActivate(e) {
        var link = e.target.closest('[data-product-thumb]');
        if (!link || !self.cache.thumbSlider) {
          return;
        }
        if (!self.cache.thumbSlider.contains(link)) {
          return;
        }
        // Only apply when in list (grid) mode. Slider mode should not jump the page.
        if (self.getThumbViewMode && self.getThumbViewMode() !== 'list') {
          return;
        }
        requestAnimationFrame(function () {
          self.scrollMainMediaIntoViewInstant();
        });
      }
      this.container.addEventListener('click', onThumbActivate);
      this.container.addEventListener('focusin', onThumbActivate);
    },

    bindThumbViewToggleOnce: function () {
      if (this.thumbViewToggleBound) {
        return;
      }
      var root = this.cache.thumbSlider;
      if (!root || !root.querySelector('[data-thumb-view-toggle]')) {
        return;
      }
      this.thumbViewToggleBound = true;
      var self = this;
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-thumb-view-toggle]');
        if (!btn) {
          return;
        }
        e.preventDefault();
        var mode = btn.getAttribute('data-thumb-view-toggle');
        if (mode !== 'list' && mode !== 'slider') {
          return;
        }
        root.dataset.viewMode = mode;
        if (
          USE_THUMB_VIEW_LOCAL_STORAGE &&
          theme.config.hasLocalStorage &&
          root.dataset.productId
        ) {
          try {
            window.localStorage.setItem('product-thumb-view-' + root.dataset.productId, mode);
          } catch (err) {}
        }
        root.classList.toggle('product__thumbs--view-list', mode === 'list');
        self.updateThumbViewToggleButtons(root);
        self.destroyThumbFlickity();
        if (mode === 'slider' && root.dataset.thumbStripFlickity === 'true') {
          try {
            self.initThumbStripFlickity();
          } catch (e) {
            thumbError('thumb toggle slider > initThumbStripFlickity', e);
          }
        }
        if (self.flickity && typeof self.flickity.syncChildNav === 'function') {
          self.flickity.syncChildNav(self.flickity.slideshow.selectedIndex);
        }
      });
    },

    /**
     * メインスライダー初期化が途中で落ちても、サムネ Flickity／トグル／枚数を後から整える。
     */
    _finalizeProductThumbUi: function () {
      if (!this.cache || !this.cache.thumbSlider) {
        return;
      }
      if (this.cache.thumbSlider.getAttribute('data-thumb-nav-style') !== 'flickity') {
        return;
      }
      // トグルは必ず先に付ける。Flickity 初期化で例外が出ると以降がスキップされ一覧ボタンが死ぬ。
      this.bindThumbViewToggleOnce();
      // Bind variant events here too, because this runs for already-initialized instances
      // (hot reload / layout stabilization) and does not depend on initVariants timing.
      this._bindVariantEventsForThumbSyncOnce();
      this.initListThumbJumpToMainOnce();
      try {
        this.ensureThumbStripFlickityIfNeeded();
      } catch (e) {
        thumbError('_finalizeProductThumbUi > ensureThumbStripFlickityIfNeeded', e);
      }
      this.updateProductSlideCounter();
      var self = this;
      requestAnimationFrame(function () {
        try {
          self.ensureThumbStripFlickityIfNeeded();
        } catch (e) {
          thumbError('_finalize rAF1 > ensureThumbStripFlickityIfNeeded', e);
        }
        self.updateProductSlideCounter();
        requestAnimationFrame(function () {
          try {
            self.ensureThumbStripFlickityIfNeeded();
          } catch (e) {
            thumbError('_finalize rAF2 > ensureThumbStripFlickityIfNeeded', e);
          }
          self.updateProductSlideCounter();
        });
      });
    },

    _slideIndex: function (el) {
      if (!el || typeof el.getAttribute !== 'function') {
        return 0;
      }
      var v = el.getAttribute('data-index');
      return v == null ? 0 : v;
    },

    initProductSlider: function (variant) {
      this.destroyThumbFlickity();

      if (this.cache.mainSlider.querySelectorAll(productSliderSelectors.slide).length <= 1) {
        var slide = this.cache.mainSlider.querySelector(productSliderSelectors.slide);
        if (slide) {
          slide.classList.add('is-selected');
        }
        this._finalizeProductThumbUi();
        return;
      }

      if (this.flickity && typeof this.flickity.destroy === 'function') {
        this.flickity.destroy();
      }

      if (!variant) {
        var activeSlide = this.cache.mainSlider.querySelector(productSliderSelectors.startingSlide);
        this.settings.currentSlideIndex = this._slideIndex(activeSlide);
      }

      this.applyThumbViewFromStorageOnce();

      // モバイルの縦スクロールを優先して、横ドラッグ誤爆を減らす。
      // touch デバイス + 小さいBPではドラッグ開始の閾値を高める。
      var mainDragThreshold = 25;
      if (theme && theme.config && theme.config.isTouch) {
        mainDragThreshold = 45;
      }
      if (theme && theme.config && theme.config.bpSmall) {
        mainDragThreshold = 70;
      }

      var useThumbStripAsNav =
        this.cache.thumbSlider &&
        this.cache.thumbSlider.dataset.thumbStripFlickity === 'true';

      var mainSliderArgs = {
        dragThreshold: mainDragThreshold,
        adaptiveHeight: false,
        avoidReflow: true,
        initialIndex: this.settings.currentSlideIndex,
        childNav: useThumbStripAsNav ? null : this.cache.thumbSlider,
        childNavScroller: useThumbStripAsNav ? null : this.cache.thumbScroller,
        childVertical:
          !useThumbStripAsNav &&
          this.cache.thumbSlider &&
          this.cache.thumbSlider.dataset.position === 'beside',
        pageDots: true,
        wrapAround: true,
        callbacks: {
          onInit: this.onSliderInit.bind(this),
          onChange: this.onSlideChange.bind(this),
        },
      };

      if (!useThumbStripAsNav) {
        mainSliderArgs.thumbFlickityGetter = function () {
          return this.getThumbFlickity();
        }.bind(this);
        mainSliderArgs.getThumbViewMode = this.getThumbViewMode.bind(this);
      }

      if (this.settings.imageSetName) {
        var imageSetArgs = this.imageSetArguments(variant);
        mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
        this.updateImageSetThumbs(mainSliderArgs.imageSet);
      }

      // #ProductPhotos-… / [data-product-photos].product-slideshow（メインギャラリー）のみ。サムネ strip とは別要素。
      mainSliderArgs.adaptiveHeight = false;
      mainSliderArgs.setGallerySize = true;

      this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);

      var mainFlk = this.flickity && this.flickity.slideshow;
      if (mainFlk) {
        mainFlk.options.adaptiveHeight = false;
        if (typeof mainFlk.resize === 'function') {
          mainFlk.resize();
        }
      }

      this.ensureMainSlideCounterBound();

      if (useThumbStripAsNav && this.getThumbViewMode() !== 'list') {
        try {
          this.initThumbStripFlickity();
        } catch (e) {
          thumbError('initProductSlider > initThumbStripFlickity', e);
        }
      }

      try {
        this.ensureThumbStripFlickityIfNeeded();
      } catch (e) {
        thumbError('initProductSlider post-main > ensureThumbStripFlickityIfNeeded', e);
      }

      this._finalizeProductThumbUi();
    },

    /**
     * メイン Flickity に change/settle をバインド（1 インスタンスにつき 1 回）。
     * init 直後は this.flickity.slideshow が未設定の瞬間があり得るため、
     * updateProductSlideCounter からも遅延バインドする。
     */
    ensureMainSlideCounterBound: function () {
      var mainFlk = this.flickity && this.flickity.slideshow;
      if (!mainFlk) {
        return;
      }
      if (mainFlk._productMainSlideCounterBound) {
        return;
      }
      if (typeof mainFlk.on !== 'function') {
        return;
      }
      mainFlk._productMainSlideCounterBound = true;
      var self = this;
      mainFlk.on('ready', function () {
        self.updateProductSlideCounter();
      });
      mainFlk.on('change', function () {
        self.updateProductSlideCounter();
      });
      mainFlk.on('settle', function () {
        self.updateProductSlideCounter();
      });
    },

    /**
     * wrapAround 時、Flickity の selectedIndex / change の index はセル配列用で
     * メディアの data-index（0..n-1）と一致しないことがある。
     * セル要素の data-index から論理インデックスを取る。
     * @param {number} [cellIndexHint] change コールバックで渡るセル index（selectedIndex が未更新のとき用）
     */
    getMainSlideLogicalIndex0: function (flk, cellIndexHint) {
      if (!flk || !flk.cells) {
        return 0;
      }
      var ci =
        typeof cellIndexHint === 'number' &&
        cellIndexHint >= 0 &&
        cellIndexHint < flk.cells.length
          ? cellIndexHint
          : flk.selectedIndex;
      if (typeof ci !== 'number' || ci < 0 || ci >= flk.cells.length) {
        return 0;
      }
      var cell = flk.cells[ci];
      if (!cell || !cell.element) {
        return 0;
      }
      var node = cell.element;
      var slide =
        node.classList && node.classList.contains('product-main-slide')
          ? node
          : node.querySelector
            ? node.querySelector('.product-main-slide')
            : null;
      if (!slide && node.closest) {
        slide = node.closest('.product-main-slide');
      }
      if (!slide) {
        return 0;
      }
      var di = slide.getAttribute('data-index');
      if (di == null || di === '') {
        return 0;
      }
      var n = parseInt(di, 10);
      return isNaN(n) ? 0 : n;
    },

    /**
     * メインスライドの alt が商品タイトルと異なる場合のみ、画像下に表示する。
     * 表示/非表示は .is-visible + grid トランジション（theme-custom.css）。
     */
    updateProductMainCaption: function () {
      var wrap = this.container.querySelector('[data-product-main-caption-wrap]');
      if (!wrap) {
        return;
      }
      var textEl = wrap.querySelector('[data-product-main-caption]');
      if (!textEl) {
        return;
      }
      var slide = null;
      if (this.flickity && this.flickity.slideshow) {
        var logical0 = this.getMainSlideLogicalIndex0(this.flickity.slideshow);
        slide = this.cache.mainSlider.querySelector(
          '.product-main-slide[data-index="' + logical0 + '"]'
        );
      } else {
        slide =
          this.cache.mainSlider.querySelector('.product-main-slide.is-selected') ||
          this.cache.mainSlider.querySelector('.product-main-slide');
      }

      var cap = slide ? slide.getAttribute('data-main-caption') : null;
      var hasCaption = cap != null && cap !== '';

      if (!hasCaption) {
        if (!wrap.classList.contains('is-visible')) {
          wrap.removeAttribute('hidden');
          wrap.setAttribute('aria-hidden', 'true');
          textEl.textContent = '';
          return;
        }
        wrap.classList.remove('is-visible');
        wrap.setAttribute('aria-hidden', 'true');
        wrap.removeAttribute('hidden');

        if (wrap._captionTransitionEnd) {
          wrap.removeEventListener('transitionend', wrap._captionTransitionEnd);
          wrap._captionTransitionEnd = null;
        }

        wrap._captionTransitionEnd = function (e) {
          if (e.target !== wrap || e.propertyName !== 'grid-template-rows') {
            return;
          }
          if (!wrap.classList.contains('is-visible')) {
            textEl.textContent = '';
          }
          wrap.removeEventListener('transitionend', wrap._captionTransitionEnd);
          wrap._captionTransitionEnd = null;
        };
        wrap.addEventListener('transitionend', wrap._captionTransitionEnd);
        return;
      }

      if (wrap._captionTransitionEnd) {
        wrap.removeEventListener('transitionend', wrap._captionTransitionEnd);
        wrap._captionTransitionEnd = null;
      }

      textEl.textContent = cap;
      wrap.removeAttribute('hidden');
      wrap.setAttribute('aria-hidden', 'false');

      if (wrap.classList.contains('is-visible')) {
        return;
      }

      requestAnimationFrame(function () {
        wrap.classList.add('is-visible');
      });
    },

    updateProductSlideCounter: function () {
      var el = this.container.querySelector('[data-product-slide-counter]');
      if (!el) {
        this.updateProductMainCaption();
        return;
      }
      if (!this.flickity || !this.flickity.slideshow) {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
        this.updateProductMainCaption();
        return;
      }
      this.ensureMainSlideCounterBound();
      var flk = this.flickity.slideshow;
      var totEl = el.querySelector('[data-slide-counter-total]');
      var total = 0;
      if (totEl && totEl.textContent) {
        var parsed = parseInt(String(totEl.textContent).trim(), 10);
        if (!isNaN(parsed) && parsed > 0) {
          total = parsed;
        }
      }
      if (total < 1) {
        var slideEls = this.cache.mainSlider.querySelectorAll(productSliderSelectors.slide);
        total = slideEls.length;
      }
      var logical0 = this.getMainSlideLogicalIndex0(flk);
      var current = logical0 + 1;
      if (total >= 1 && current > total) {
        current = total;
      }
      if (total < 1) {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
        this.updateProductMainCaption();
        return;
      }
      var curEl = el.querySelector('[data-slide-counter-current]');
      if (curEl) {
        curEl.textContent = String(current);
      }
      el.removeAttribute('hidden');
      el.setAttribute('aria-hidden', 'false');
      this.updateProductMainCaption();
    },

    onSlideChange: function (index) {
      var self = this;
      try {
        if (!this.flickity) {
          return;
        }
        var flk = this.flickity.slideshow;
        if (!flk) {
          return;
        }
        var logicalNext0 = this.getMainSlideLogicalIndex0(flk, typeof index === 'number' ? index : undefined);

        var prevSlide = this.cache.mainSlider.querySelector(
          '.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]'
        );

        var nextSlide;
        if (this.settings.imageSetName) {
          nextSlide = this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index];
        } else {
          nextSlide = this.cache.mainSlider.querySelector(
            '.product-main-slide[data-index="' + logicalNext0 + '"]'
          );
        }

        try {
          if (!prevSlide || !nextSlide) {
            return;
          }

          prevSlide.setAttribute('tabindex', '-1');
          nextSlide.setAttribute('tabindex', 0);

          this.stopMediaOnSlide(prevSlide);

          this.prepMediaOnSlide(nextSlide);
        } catch (e) {
          thumbError('onSlideChange media', e);
        }
      } catch (e) {
        thumbError('onSlideChange', e);
      } finally {
        if (self.flickity && self.flickity.slideshow) {
          self.settings.currentSlideIndex = self.getMainSlideLogicalIndex0(
            self.flickity.slideshow,
            typeof index === 'number' ? index : undefined
          );
        }
        self.updateProductSlideCounter();
      }
    },
  });

  var productInitOriginal = theme.Product.prototype.init;
  theme.Product.prototype.init = function () {
    try {
      productInitOriginal.call(this);
    } finally {
      if (typeof this._finalizeProductThumbUi === 'function') {
        try {
          this._finalizeProductThumbUi();
        } catch (e) {
          thumbError('Product.init finally > _finalizeProductThumbUi', e);
        }
      }
      try {
        if (typeof this.updateProductMainCaption === 'function') {
          this.updateProductMainCaption();
        }
      } catch (e) {
        thumbError('Product.init finally > updateProductMainCaption', e);
      }
    }
  };

  /**
   * theme.sections は theme.js の DOMContentLoaded 内で生成される。
   * Hot Reload・画像レイアウト後など、初回 init 時点ではサムネ DOM／計測が未確定で
   * Flickity／トグルが付かないことがあるため、DOM 安定後にもう一度整える。
   */
  function runDeferredProductThumbFinalize(reason) {
    try {
      if (!theme.sections || !theme.sections.instances || !theme.sections.instances.length) {
        return;
      }
      for (var i = 0; i < theme.sections.instances.length; i++) {
        var inst = theme.sections.instances[i];
        if (inst.type === 'product' && typeof inst._finalizeProductThumbUi === 'function') {
          try {
            inst._finalizeProductThumbUi();
          } catch (e) {
            thumbError('deferred thumb finalize (' + reason + ') section ' + inst.id, e);
          }
        }
      }
    } catch (e) {
      thumbError('deferred thumb finalize (' + reason + ')', e);
    }
  }

  function scheduleDeferredProductThumbFinalize() {
    function afterLayoutPass(label) {
      requestAnimationFrame(function () {
        runDeferredProductThumbFinalize(label + '+rAF1');
        requestAnimationFrame(function () {
          runDeferredProductThumbFinalize(label + '+rAF2');
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          afterLayoutPass('DOMContentLoaded');
        },
        { once: true }
      );
    } else {
      afterLayoutPass('already-parsed');
    }
    window.addEventListener(
      'load',
      function () {
        runDeferredProductThumbFinalize('window.load');
      },
      { once: true }
    );
  }

  scheduleDeferredProductThumbFinalize();

  /** 商品説明タブ: max-height プレビュー + グラデーション上の「続きを読む」 */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-description-preview-toggle]');
    if (!btn) {
      return;
    }
    e.preventDefault();
    var shell = btn.closest('[data-description-preview-root]');
    if (!shell) {
      return;
    }
    var body = shell.querySelector('.product-description-preview__body');
    if (!body) {
      return;
    }
    var more = btn.getAttribute('data-text-more') || '';
    var less = btn.getAttribute('data-text-less') || '';
    var expanded = shell.classList.toggle('is-expanded');
    body.classList.toggle('is-expanded', expanded);
    btn.textContent = expanded ? less : more;
    var collapsible = btn.closest('.collapsible-content');
    if (collapsible) {
      collapsible.style.height = 'auto';
    }
    if (!expanded) {
      var scrollAnchor = shell.closest('.collapsibles-wrapper') || shell;
      var scrollDocTop = function () {
        var st = window.scrollY || document.documentElement.scrollTop || 0;
        return scrollAnchor.getBoundingClientRect().top + st;
      };
      var viewportTopObstructionBottom = function () {
        var bottom = 0;
        var consider = function (el) {
          if (!el || !el.getBoundingClientRect) {
            return;
          }
          var cs = window.getComputedStyle(el);
          if (cs.display === 'none' || cs.visibility === 'hidden') {
            return;
          }
          var r = el.getBoundingClientRect();
          if (!r.height) {
            return;
          }
          if (r.bottom > 0 && r.top < window.innerHeight) {
            bottom = Math.max(bottom, r.bottom);
          }
        };
        // Impulse: スティッキー時は #SiteHeader が position:fixed のため、親 .header-sticky-wrapper だけでは高さが取れない
        var stuckSiteHeader = document.querySelector('#SiteHeader.site-header--stuck');
        if (stuckSiteHeader) {
          consider(stuckSiteHeader);
          if (bottom < 8) {
            bottom = Math.max(bottom, stuckSiteHeader.offsetHeight || 0);
          }
        }
        consider(document.querySelector('.announcement-bar'));
        consider(document.querySelector('.toolbar'));
        if (bottom === 0) {
          consider(document.querySelector('.header-sticky-wrapper'));
        }
        return Math.max(0, bottom);
      };
      var doScroll = function () {
        var belowFixed = viewportTopObstructionBottom();
        var gap = 12;
        var topTarget = scrollDocTop() - belowFixed - gap;
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, topTarget), behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      // 折りたたみ後の max-height／absolute にレイアウトが追いついてから 1 回だけ合わせる
      window.setTimeout(doScroll, 48);
    }
  });

  function initProductDescriptionPreviewToggles() {
    document.querySelectorAll('[data-description-preview-root]').forEach(function (shell) {
      var body = shell.querySelector('.product-description-preview__body');
      var btn = shell.querySelector('[data-description-preview-toggle]');
      if (!body || !btn) {
        return;
      }
      var maxH = parseInt(shell.getAttribute('data-preview-height'), 10);
      if (isNaN(maxH) || maxH <= 0) {
        return;
      }
      requestAnimationFrame(function () {
        if (body.scrollHeight <= maxH + 8) {
          shell.classList.add('is-expanded');
          body.classList.add('is-expanded');
          btn.hidden = true;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductDescriptionPreviewToggles, { once: true });
  } else {
    initProductDescriptionPreviewToggles();
  }
})();

/**
 * SKU一覧モーダル（theme.Modals準拠） + ボタンsticky表示 + 画像プレビュー拡大
 */
(function () {
  'use strict';

  function visibilityAllows(visibility) {
    var mq = window.matchMedia('(min-width: 769px)');
    if (visibility === 'mobile') {
      return !mq.matches;
    }
    if (visibility === 'desktop') {
      return mq.matches;
    }
    return true; // all
  }

  var skuListStickyResizeObserver = null;

  function syncSkuListStickyHeight(stickyWrap) {
    if (!stickyWrap || stickyWrap.hidden) {
      document.documentElement.style.removeProperty('--sku-list-sticky-height');
      return;
    }

    var h = Math.ceil(stickyWrap.getBoundingClientRect().height);
    if (h > 0) {
      document.documentElement.style.setProperty('--sku-list-sticky-height', h + 'px');
    }
  }

  function startSkuListStickyHeightWatch(stickyWrap) {
    if (!stickyWrap) {
      return;
    }

    requestAnimationFrame(function () {
      syncSkuListStickyHeight(stickyWrap);
    });

    if (typeof ResizeObserver !== 'function') {
      return;
    }

    if (skuListStickyResizeObserver) {
      skuListStickyResizeObserver.disconnect();
    }

    skuListStickyResizeObserver = new ResizeObserver(function () {
      syncSkuListStickyHeight(stickyWrap);
    });
    skuListStickyResizeObserver.observe(stickyWrap);
  }

  function stopSkuListStickyHeightWatch() {
    document.documentElement.style.removeProperty('--sku-list-sticky-height');
    if (skuListStickyResizeObserver) {
      skuListStickyResizeObserver.disconnect();
      skuListStickyResizeObserver = null;
    }
  }

  function setSkuListStickyActive(active, stickyWrap) {
    if (active) {
      document.body.classList.add('sku-list-sticky-active');
      startSkuListStickyHeightWatch(stickyWrap);
      return;
    }

    document.body.classList.remove('sku-list-sticky-active');
    stopSkuListStickyHeightWatch();
  }

  /**
   * Quick view 内では SKU モーダルが QuickShop の .modal__inner の子になる。
   * クリックがバブルすると QuickShop 側の closeOffContentClick も反応してしまうため止める。
   */
  function stopSkuListModalClickBubblingToQuickShop(modalEl) {
    if (!modalEl || modalEl.getAttribute('data-sku-list-stop-bubble') === '1') {
      return;
    }
    modalEl.setAttribute('data-sku-list-stop-bubble', '1');
    modalEl.addEventListener(
      'click',
      function (e) {
        e.stopPropagation();
      },
      false
    );
  }

  function initSkuListSwymButtons(modalEl) {
    if (!modalEl || !modalEl.querySelector) {
      return;
    }
    var selector = '.sku-list-modal__wishlist.swym-button';
    if (!modalEl.querySelector(selector)) {
      return;
    }

    function runInit(swat) {
      if (!swat || typeof swat.initializeActionButtons !== 'function') {
        return;
      }
      try {
        var containerSelector = modalEl.id ? '#' + modalEl.id : '.modal--sku-list';
        swat.initializeActionButtons(containerSelector, selector);
      } catch (err) {}
    }

    if (window._swat) {
      runInit(window._swat);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(runInit);
  }

  var pdpWishlistRefreshTimer = null;

  function refreshPdpWishlistTrigger(root) {
    if (!root || !root.querySelector) {
      return;
    }
    var triggers = root.querySelectorAll('[data-sku-pdp-wishlist-trigger]');
    if (!triggers.length) {
      return;
    }
    var productId = root.getAttribute('data-product-id');
    if (!productId) {
      return;
    }

    function applyActive(active) {
      triggers.forEach(function (btn) {
        btn.classList.toggle('is-wishlisted', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function runFetch(swat) {
      if (!swat || typeof swat.fetch !== 'function') {
        return;
      }
      try {
        swat.fetch(function (products) {
          var list = products || [];
          var active = list.some(function (item) {
            return item && String(item.empi) === String(productId);
          });
          applyActive(active);
        });
      } catch (err) {}
    }

    if (window._swat) {
      runFetch(window._swat);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(runFetch);
  }

  function schedulePdpWishlistRefresh(root) {
    if (!root) {
      return;
    }
    if (pdpWishlistRefreshTimer) {
      clearTimeout(pdpWishlistRefreshTimer);
    }
    pdpWishlistRefreshTimer = setTimeout(function () {
      pdpWishlistRefreshTimer = null;
      refreshPdpWishlistTrigger(root);
    }, 120);
  }

  function bindPdpWishlistTriggerSync(root, modalDomId, modalEl) {
    if (!root || root.getAttribute('data-pdp-wishlist-sync') === '1') {
      return;
    }
    if (!root.querySelector('[data-sku-pdp-wishlist-trigger]')) {
      return;
    }
    root.setAttribute('data-pdp-wishlist-sync', '1');

    refreshPdpWishlistTrigger(root);

    if (modalDomId) {
      document.addEventListener('modalOpen.' + modalDomId, function () {
        schedulePdpWishlistRefresh(root);
      });
      document.addEventListener('modalClose.' + modalDomId, function () {
        schedulePdpWishlistRefresh(root);
      });
    }

    if (modalEl) {
      modalEl.addEventListener(
        'click',
        function (e) {
          if (e.target.closest && e.target.closest('.sku-list-modal__wishlist')) {
            schedulePdpWishlistRefresh(root);
          }
        },
        false
      );
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function () {
      schedulePdpWishlistRefresh(root);
    });
  }

  function bindSkuListBackdropOutsidePanel(modalEl, inst) {
    if (!modalEl || !inst || modalEl.getAttribute('data-sku-list-backdrop-outside') === '1') {
      return;
    }
    modalEl.setAttribute('data-sku-list-backdrop-outside', '1');
    modalEl.addEventListener(
      'click',
      function (e) {
        if (!inst.modalIsOpen) {
          return;
        }
        if (e.target.closest && e.target.closest('.js-modal-close')) {
          return;
        }
        var panel = modalEl.querySelector('.modal__centered-content');
        if (panel && panel.contains(e.target)) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        inst.close(e);
      },
      false
    );
  }

  function bindSkuListRoot(root) {
    if (!root || root.getAttribute('data-sku-list-bound') === '1') {
      return;
    }

    var modalId = root.getAttribute('data-sku-list-modal-id');
    if (!modalId) {
      return;
    }

    // Quick view: theme.js が注入後に id に `-modal` を付けるため data 属性の id とずれる。
    // 常にこのルート配下のモーダルノードを使う（通常 PDP でも同じ）。
    var modalEl = root.querySelector('.modal.modal--sku-list');
    if (!modalEl && typeof document.getElementById === 'function') {
      modalEl = document.getElementById(modalId) || document.getElementById(modalId + '-modal');
    }
    var modalDomId = modalEl && modalEl.id;
    if (!modalEl || !modalDomId || !window.theme || !theme.Modals) {
      return;
    }

    root.setAttribute('data-sku-list-bound', '1');

    // Modal init (scoped open selector to this product/modal)
    try {
      // closeOffContentClick: theme 標準は .modal__inner 全体を「内側」とみなすため、
      // 白パネル外（余白・オーバーレイ）クリックで閉じない。SKU は centered-content 外で閉じる。
      var skuModalInstance = new theme.Modals(modalDomId, 'sku-list', {
        open: '.js-modal-open-sku-list[data-sku-list-modal-open="' + modalId + '"]',
        closeOffContentClick: false
      });
      root._skuListModal = skuModalInstance;
      if (skuModalInstance && typeof skuModalInstance.close === 'function') {
        stopSkuListModalClickBubblingToQuickShop(modalEl);
        bindSkuListBackdropOutsidePanel(modalEl, skuModalInstance);
      }
      document.addEventListener('modalOpen.' + modalDomId, function () {
        initSkuListSwymButtons(modalEl);
        schedulePdpWishlistRefresh(root);
      });
      initSkuListSwymButtons(modalEl);
      bindPdpWishlistTriggerSync(root, modalDomId, modalEl);
    } catch (e) {
      // Fail silently; do not break PDP
    }

    // Sticky button
    var stickyVisibility = root.getAttribute('data-sku-list-sticky-visibility') || 'mobile';
    var stickyBehavior = root.getAttribute('data-sku-list-sticky-behavior') || 'passed';
    var sentinel = root.querySelector('[data-sku-list-sticky-sentinel]');
    var stickyWrap = root.querySelector('[data-sku-list-sticky]');

    function syncSkuListStickyAlwaysState() {
      if (!stickyWrap || stickyBehavior !== 'always') {
        return;
      }
      var allowSticky = visibilityAllows(stickyVisibility);
      stickyWrap.hidden = !allowSticky;
      if (allowSticky) {
        setSkuListStickyActive(true, stickyWrap);
        root.removeAttribute('data-sku-list-sticky-fallback-actions');
      } else {
        setSkuListStickyActive(false, stickyWrap);
        root.setAttribute('data-sku-list-sticky-fallback-actions', '1');
      }
    }

    if (stickyWrap && stickyBehavior === 'always') {
      syncSkuListStickyAlwaysState();
      try {
        var mqAlways = window.matchMedia('(min-width: 769px)');
        var onAlwaysViewport = function () {
          syncSkuListStickyAlwaysState();
        };
        if (mqAlways.addEventListener) {
          mqAlways.addEventListener('change', onAlwaysViewport);
        } else if (mqAlways.addListener) {
          mqAlways.addListener(onAlwaysViewport);
        }
        window.addEventListener('resize', onAlwaysViewport, { passive: true });
      } catch (errAlways) {}
    } else if (sentinel && stickyWrap && typeof IntersectionObserver === 'function') {
      var docked = false;

      function setDocked(active) {
        if (active === docked) return;
        docked = active;
        if (active && visibilityAllows(stickyVisibility)) {
          stickyWrap.hidden = false;
          setSkuListStickyActive(true, stickyWrap);
        } else {
          stickyWrap.hidden = true;
          setSkuListStickyActive(false, stickyWrap);
        }
      }

      function computeDockedByRect() {
        if (stickyBehavior === 'always') {
          return true;
        }
        try {
          var r = sentinel.getBoundingClientRect();
          if (stickyBehavior === 'out_of_view') {
            // Show sticky when the original button area (sentinel) is outside viewport:
            // - above the viewport (scrolled past)
            // - or below the viewport (not reached yet)
            var vh = window.innerHeight || document.documentElement.clientHeight || 0;
            return r.bottom <= 0 || r.top >= vh;
          }
          // Default: show only after passing the button area.
          return r.bottom <= 0;
        } catch (e) {
          return docked;
        }
      }

      function refreshDockState() {
        if (!visibilityAllows(stickyVisibility)) {
          setDocked(false);
          return;
        }
        setDocked(computeDockedByRect());
      }

      var observer = new IntersectionObserver(function (entries) {
        if (!visibilityAllows(stickyVisibility)) {
          setDocked(false);
          return;
        }
        // Use IO only as a signal that visibility changed.
        // The actual docked state is computed from layout (rect) to avoid
        // transient isIntersecting values during initial paint on mobile.
        refreshDockState();
      }, { root: null, rootMargin: '0px', threshold: 0 });

      observer.observe(sentinel);
      // Ensure correct initial state after layout settles
      refreshDockState();
      window.requestAnimationFrame(function () {
        refreshDockState();
        window.requestAnimationFrame(refreshDockState);
      });

      function onResizeOrMq() {
        refreshDockState();
      }
      window.addEventListener('resize', onResizeOrMq, { passive: true });
      window.addEventListener('scroll', onResizeOrMq, { passive: true });
      try {
        var mqList = window.matchMedia('(min-width: 769px)');
        if (mqList.addEventListener) mqList.addEventListener('change', onResizeOrMq);
        else if (mqList.addListener) mqList.addListener(onResizeOrMq);
      } catch (err) {}
    }

    // Image preview swap/close (inside modal)
    modalEl.addEventListener('click', function (e) {
      var closeBtn = e.target && e.target.closest ? e.target.closest('[data-sku-list-preview-close]') : null;
      if (closeBtn) {
        var previewClose = modalEl.querySelector('[data-sku-list-preview]');
        if (previewClose) {
          previewClose.hidden = true;
        }
        return;
      }

      var backdrop = e.target && e.target.closest ? e.target.closest('[data-sku-list-preview-backdrop]') : null;
      if (backdrop) {
        var previewBackdropClose = modalEl.querySelector('[data-sku-list-preview]');
        if (previewBackdropClose) {
          previewBackdropClose.hidden = true;
        }
        return;
      }

      var btn = e.target && e.target.closest ? e.target.closest('[data-sku-list-thumb]') : null;
      if (!btn) return;
      var preview = modalEl.querySelector('[data-sku-list-preview]');
      var img = modalEl.querySelector('[data-sku-list-preview-img]');
      if (!preview || !img) return;
      var src = btn.getAttribute('data-preview-src');
      if (!src) return;
      img.src = src;
      img.alt = btn.getAttribute('data-preview-alt') || '';
      preview.hidden = false;
    });

    // Swipe down to close preview (mobile usability)
    (function bindPreviewSwipeClose() {
      var preview = modalEl.querySelector('[data-sku-list-preview]');
      if (!preview || preview.getAttribute('data-sku-list-swipe-bound') === '1') {
        return;
      }
      preview.setAttribute('data-sku-list-swipe-bound', '1');

      var inner = preview.querySelector('.sku-list-modal__preview-inner');
      if (!inner) return;

      var startY = 0;
      var currentY = 0;
      var tracking = false;

      function setTranslate(y) {
        inner.style.transform = y ? 'translate3d(0,' + y + 'px,0)' : '';
        inner.style.opacity = y ? String(Math.max(0.25, 1 - y / 240)) : '';
      }

      function reset() {
        inner.classList.remove('is-dragging');
        setTranslate(0);
      }

      function closePreview() {
        reset();
        preview.hidden = true;
      }

      inner.addEventListener('touchstart', function (evt) {
        if (preview.hidden) return;
        // 2本指以上（ピンチズーム等）はブラウザに委ねる
        if (evt.touches && evt.touches.length > 1) {
          tracking = false;
          return;
        }
        var t = evt.touches && evt.touches[0];
        if (!t) return;
        tracking = true;
        startY = t.clientY;
        currentY = 0;
        inner.classList.add('is-dragging');
      }, { passive: true });

      inner.addEventListener('touchmove', function (evt) {
        if (!tracking || preview.hidden) return;
        // 2本指以上はピンチズームを邪魔しない
        if (evt.touches && evt.touches.length > 1) {
          tracking = false;
          reset();
          return;
        }
        var t = evt.touches && evt.touches[0];
        if (!t) return;
        var dy = t.clientY - startY;
        currentY = dy;
        // Only animate down-drag (matches typical close gesture),
        // but allow closing for both directions by threshold on touchend.
        setTranslate(currentY > 0 ? currentY : 0);
        // Prevent background scroll while dragging the preview
        if (evt.cancelable) evt.preventDefault();
      }, { passive: false });

      inner.addEventListener('touchend', function () {
        if (!tracking) return;
        tracking = false;
        if (Math.abs(currentY) > 90) {
          closePreview();
        } else {
          reset();
        }
      });
      inner.addEventListener('touchcancel', function () {
        tracking = false;
        reset();
      });
    })();
  }

  function scan(root) {
    var el = root || document;
    if (!el.querySelectorAll) return;
    el.querySelectorAll('[data-sku-list-modal-root]').forEach(bindSkuListRoot);
  }

  /**
   * Quick view は preload で QuickShopHolder に差し込まれるだけで section:load が無い。
   * QuickShop を開いたタイミングでも再スキャンする。
   *
   * Flickity 等で祖先に transform があると position:fixed の QuickShop がビューポートに張り付かない。
   * 開いた瞬間だけ body 直下へ移し、閉じたら元の位置へ戻す（TOP featured スライダー等）。
   */
  function quickShopModalAncestorHasTransform(modalEl) {
    var el = modalEl && modalEl.parentElement;
    while (el && el !== document.documentElement) {
      try {
        var st = window.getComputedStyle(el);
        var tf = st.transform || st.webkitTransform;
        if (tf && tf !== 'none') {
          return true;
        }
        if (st.filter && st.filter !== 'none') {
          return true;
        }
        if (st.perspective && st.perspective !== 'none') {
          return true;
        }
      } catch (err) {}
      el = el.parentElement;
    }
    return false;
  }

  function reparentQuickShopModalEscapeTransform() {
    var qs = document.querySelector('.modal.modal--quick-shop.modal--is-active');
    if (!qs || qs.getAttribute('data-qs-reparented') === '1') {
      return;
    }
    if (!quickShopModalAncestorHasTransform(qs)) {
      return;
    }
    var ph = document.createComment('quick-shop-reparent');
    qs.parentNode.insertBefore(ph, qs);
    document.body.appendChild(qs);
    qs.setAttribute('data-qs-reparented', '1');
    qs.__qsReparentPlaceholder = ph;

    var modalId = qs.id;
    if (!modalId) {
      qs.removeAttribute('data-qs-reparented');
      delete qs.__qsReparentPlaceholder;
      if (ph.parentNode) {
        ph.parentNode.insertBefore(qs, ph);
        ph.parentNode.removeChild(ph);
      }
      return;
    }

    function onQuickShopClose() {
      document.removeEventListener('modalClose.' + modalId, onQuickShopClose);
      var placeholder = qs.__qsReparentPlaceholder;
      delete qs.__qsReparentPlaceholder;
      if (placeholder && placeholder.parentNode && qs.getAttribute('data-qs-reparented') === '1') {
        placeholder.parentNode.insertBefore(qs, placeholder);
        placeholder.parentNode.removeChild(placeholder);
      }
      qs.removeAttribute('data-qs-reparented');
    }

    document.addEventListener('modalClose.' + modalId, onQuickShopClose);
  }

  function observeQuickShopHolders() {
    document.querySelectorAll('[id^="QuickShopHolder-"]').forEach(function (holder) {
      if (!holder || holder.getAttribute('data-sku-list-qv-observe') === '1') {
        return;
      }
      holder.setAttribute('data-sku-list-qv-observe', '1');
      try {
        var mo = new MutationObserver(function () {
          scan(holder);
        });
        mo.observe(holder, { childList: true, subtree: true });
      } catch (e) {}
    });
  }

  var skuListCartFormDelegateBound = false;

  /**
   * variant picker / メイン product-form が無い場合でも、カートドロワー用に .js で追加する。
   */
  function bindSkuListModalCartFormsOnce() {
    if (skuListCartFormDelegateBound) {
      return;
    }
    skuListCartFormDelegateBound = true;

    var submitLock = false;

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.classList || !form.classList.contains('sku-list-modal__form')) {
          return;
        }
        if (!window.theme || !theme.routes || !theme.routes.cartAdd) {
          return;
        }

        e.preventDefault();

        if (submitLock) {
          return;
        }

        var btn = form.querySelector('button[type="submit"]');
        if (btn && btn.disabled) {
          return;
        }

        submitLock = true;
        if (btn) {
          btn.classList.add('btn--loading');
        }

        var prevErr = form.querySelector('.errors');
        if (prevErr) {
          prevErr.remove();
        }

        var data = new FormData(form);

        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin'
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (res) {
            if (res.status === 422) {
              var msg = res.description;
              if (typeof msg === 'object') {
                msg = res.message || '';
              }
              var errorDiv = document.createElement('div');
              errorDiv.className = 'errors text-center';
              errorDiv.textContent = msg || 'カートに追加できませんでした';
              form.appendChild(errorDiv);
              return;
            }

            if (document.body.classList.contains('template-cart')) {
              window.scrollTo(0, 0);
              window.location.reload();
              return;
            }

            if (theme.settings && theme.settings.cartType === 'page') {
              window.location = theme.routes.cartPage;
              return;
            }

            form.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: res,
                  addToCartBtn: btn
                },
                bubbles: true
              })
            );
          })
          .catch(function () {
            var errorDiv = document.createElement('div');
            errorDiv.className = 'errors text-center';
            errorDiv.textContent = 'カートに追加できませんでした';
            form.appendChild(errorDiv);
          })
          .finally(function () {
            submitLock = false;
            if (btn) {
              btn.classList.remove('btn--loading');
            }
          });
      },
      true
    );
  }

  var skuListBisDelegateBound = false;
  var ordersifySectionFetchPromises = {};
  var ordersifyIframePromises = {};

  function getWishlistOrdersifyHost() {
    var host = document.querySelector('[data-wishlist-ordersify-host]');
    if (!host) {
      host = document.createElement('div');
      host.setAttribute('data-wishlist-ordersify-host', '');
      host.className = 'wishlist-ordersify-host';
      host.setAttribute('aria-hidden', 'true');
      host.innerHTML =
        '<form action="/cart/add" method="post" data-wishlist-ordersify-form><input type="hidden" name="id" value=""></form>';
      document.body.appendChild(host);
    }
    return host;
  }

  function findOrdersifyInlineButton(productHandle) {
    var host = document.querySelector('[data-wishlist-ordersify-host]');
    if (host && productHandle) {
      var hostedBtn = host.querySelector('.osf_inline_button');
      if (hostedBtn && host.getAttribute('data-ordersify-handle') === productHandle) {
        return hostedBtn;
      }
    }

    var pageButtons = document.querySelectorAll('.osf_inline_button');
    var i;
    for (i = 0; i < pageButtons.length; i++) {
      if (!pageButtons[i].closest('[data-wishlist-ordersify-host]')) {
        return pageButtons[i];
      }
    }

    if (host) {
      return host.querySelector('.osf_inline_button');
    }
    return null;
  }

  function runOrdersifyScriptsFromNode(sourceNode, targetNode) {
    if (!sourceNode || !targetNode) {
      return;
    }
    var scripts = sourceNode.querySelectorAll('script');
    Array.prototype.forEach.call(scripts, function (oldScript) {
      var script = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        script.setAttribute(attr.name, attr.value);
      });
      script.textContent = oldScript.textContent;
      targetNode.appendChild(script);
    });
  }

  function waitForOrdersifyInlineButton(root, attempt) {
    return new Promise(function (resolve, reject) {
      var btn = root && root.querySelector('.osf_inline_button');
      if (btn) {
        resolve(btn);
        return;
      }
      if (attempt >= 30) {
        reject(new Error('ordersify button timeout'));
        return;
      }
      window.setTimeout(function () {
        waitForOrdersifyInlineButton(root, attempt + 1)
          .then(resolve)
          .catch(reject);
      }, 100);
    });
  }

  function waitForIframeOrdersifyButton(iframe, attempt) {
    return new Promise(function (resolve, reject) {
      try {
        var doc = iframe.contentDocument;
        if (doc && doc.querySelector('.osf_inline_button')) {
          resolve(iframe);
          return;
        }
      } catch (err) {}
      if (attempt >= 50) {
        reject(new Error('iframe ordersify timeout'));
        return;
      }
      window.setTimeout(function () {
        waitForIframeOrdersifyButton(iframe, attempt + 1)
          .then(resolve)
          .catch(reject);
      }, 200);
    });
  }

  function portalOrdersifyFromIframe(iframe) {
    var elapsed = 0;
    var interval = window.setInterval(function () {
      elapsed += 100;
      try {
        var doc = iframe.contentDocument;
        if (!doc) {
          return;
        }
        var nodes = doc.querySelectorAll('.osf_popup_overlay, .osf_dialog, .osf_popup');
        Array.prototype.forEach.call(nodes, function (el) {
          if (el.parentNode && el.parentNode !== document.body) {
            document.body.appendChild(el);
          }
        });
      } catch (err) {}
      if (elapsed >= 8000 || document.querySelector('.osf_popup_overlay')) {
        window.clearInterval(interval);
      }
    }, 100);
  }

  function ensureOrdersifyViaIframe(productHandle) {
    if (!productHandle) {
      return Promise.reject(new Error('missing product handle'));
    }
    if (ordersifyIframePromises[productHandle]) {
      return ordersifyIframePromises[productHandle];
    }

    var existing = document.querySelector(
      'iframe[data-ordersify-product-iframe][data-product-handle="' + productHandle + '"]'
    );
    if (existing) {
      ordersifyIframePromises[productHandle] = waitForIframeOrdersifyButton(existing, 0);
      return ordersifyIframePromises[productHandle];
    }

    ordersifyIframePromises[productHandle] = new Promise(function (resolve, reject) {
      var iframe = document.createElement('iframe');
      iframe.setAttribute('data-ordersify-product-iframe', '');
      iframe.setAttribute('data-product-handle', productHandle);
      iframe.setAttribute('title', 'Ordersify product context');
      iframe.style.cssText =
        'position:fixed;width:2px;height:2px;opacity:0;pointer-events:none;border:0;left:-9999px;top:0;';
      iframe.src =
        (window.theme && theme.routes && theme.routes.home ? theme.routes.home : '/') +
        'products/' +
        encodeURIComponent(productHandle);

      var timeout = window.setTimeout(function () {
        reject(new Error('iframe timeout'));
      }, 20000);

      iframe.onload = function () {
        waitForIframeOrdersifyButton(iframe, 0)
          .then(function (readyIframe) {
            window.clearTimeout(timeout);
            resolve(readyIframe);
          })
          .catch(function (err) {
            window.clearTimeout(timeout);
            reject(err);
          });
      };

      iframe.onerror = function () {
        window.clearTimeout(timeout);
        reject(new Error('iframe load failed'));
      };

      document.body.appendChild(iframe);
    }).catch(function (err) {
      delete ordersifyIframePromises[productHandle];
      throw err;
    });

    return ordersifyIframePromises[productHandle];
  }

  function ensureOrdersifyInlineButton(productHandle) {
    if (!productHandle) {
      return Promise.reject(new Error('missing product handle'));
    }

    var host = getWishlistOrdersifyHost();
    if (
      host.getAttribute('data-ordersify-handle') === productHandle &&
      host.querySelector('.osf_inline_button')
    ) {
      return Promise.resolve();
    }

    if (ordersifySectionFetchPromises[productHandle]) {
      return ordersifySectionFetchPromises[productHandle];
    }

    var sectionUrl =
      (window.theme && theme.routes && theme.routes.home ? theme.routes.home : '/') +
      'products/' +
      encodeURIComponent(productHandle) +
      '?section_id=main';

    ordersifySectionFetchPromises[productHandle] = fetch(sectionUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('ordersify section fetch failed');
        }
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var osfBtn = doc.querySelector('.osf_inline_button');
        if (!osfBtn) {
          throw new Error('ordersify button missing');
        }

        var mount = host.querySelector('[data-wishlist-ordersify-mount]');
        if (!mount) {
          mount = document.createElement('div');
          mount.setAttribute('data-wishlist-ordersify-mount', '');
          host.appendChild(mount);
        }

        var block = osfBtn.closest('.shopify-app-block, [data-shopify-app-block], shopify-app-block');
        mount.innerHTML = '';
        if (block) {
          mount.innerHTML = block.innerHTML;
          runOrdersifyScriptsFromNode(block, mount);
        } else {
          mount.innerHTML = osfBtn.outerHTML;
        }

        host.setAttribute('data-ordersify-handle', productHandle);

        try {
          mount.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('shopify:section:load'));
        } catch (err) {}

        return waitForOrdersifyInlineButton(mount, 0);
      })
      .catch(function (err) {
        delete ordersifySectionFetchPromises[productHandle];
        return ensureOrdersifyViaIframe(productHandle);
      });

    return ordersifySectionFetchPromises[productHandle];
  }

  function getRestockVariantForm(doc) {
    doc = doc || document;
    var cartForms = doc.querySelectorAll('form[action*="/cart/add"]');
    var i;
    var form;

    for (i = 0; i < cartForms.length; i++) {
      form = cartForms[i];
      if (form.hasAttribute('data-wishlist-ordersify-form')) {
        continue;
      }
      if (form.closest('[data-wishlist-ordersify-host]')) {
        continue;
      }
      if (
        form.classList.contains('product-single__form') ||
        form.querySelector('[data-product-select]') ||
        form.querySelector('[data-variant-input]')
      ) {
        return form;
      }
    }

    for (i = 0; i < cartForms.length; i++) {
      form = cartForms[i];
      if (!form.hasAttribute('data-wishlist-ordersify-form') && !form.closest('[data-wishlist-ordersify-host]')) {
        return form;
      }
    }

    return doc.querySelector('[data-wishlist-ordersify-form]') || doc.querySelector('form[action*="/cart/add"]');
  }

  function cssEscapeAttrValue(value) {
    var str = String(value);
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(str);
    }
    return str.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function getPdpVariantById(variantId, doc) {
    doc = doc || document;
    if (!variantId) {
      return null;
    }
    var variantJsonEl = doc.querySelector('[data-variant-json]');
    if (!variantJsonEl) {
      return null;
    }
    try {
      var variants = JSON.parse(variantJsonEl.textContent);
      var id = String(variantId);
      var vi;
      for (vi = 0; vi < variants.length; vi++) {
        if (String(variants[vi].id) === id) {
          return variants[vi];
        }
      }
    } catch (err) {}
    return null;
  }

  function ensureMasterSelectOption(form, variant) {
    if (!form || !variant) {
      return false;
    }
    var masterSelect = form.querySelector('select[name="id"]');
    if (!masterSelect) {
      return false;
    }

    var id = String(variant.id);
    var safeId = cssEscapeAttrValue(id);
    var option = masterSelect.querySelector('option[value="' + safeId + '"]');
    if (!option) {
      option = document.createElement('option');
      option.value = id;
      option.textContent = variant.public_title || variant.title || id;
      masterSelect.appendChild(option);
    }

    masterSelect.value = id;
    try {
      masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (err) {}
    return true;
  }

  function syncPdpSkuDisplay(variant, doc) {
    doc = doc || document;
    if (!variant || !variant.sku) {
      return;
    }
    doc.querySelectorAll('[data-sku]').forEach(function (skuEl) {
      skuEl.textContent = variant.sku;
    });
  }

  function dispatchPdpVariantChange(variant, doc) {
    doc = doc || document;
    if (!variant) {
      return;
    }
    var container =
      doc.querySelector('[data-product-id]') ||
      doc.querySelector('.product-single') ||
      doc.querySelector('.product-section') ||
      doc;
    var detail = { variant: variant };
    try {
      container.dispatchEvent(new CustomEvent('variantChange', { detail: detail }));
      doc.dispatchEvent(new CustomEvent('variant:change', { detail: detail }));
      container.dispatchEvent(new CustomEvent('variantSKUChange', { detail: detail }));
    } catch (err) {}
  }

  function setVariantRadiosChecked(variant, doc) {
    doc = doc || document;
    if (!variant) {
      return;
    }
    ['option1', 'option2', 'option3'].forEach(function (key, idx) {
      var val = variant[key];
      if (!val) {
        return;
      }
      var safeVal = cssEscapeAttrValue(val);
      var input = doc.querySelector(
        '[data-variant-input][data-index="option' + (idx + 1) + '"][value="' + safeVal + '"]'
      );
      if (input) {
        input.checked = true;
      }
    });
  }

  function triggerOrdersifyInDocument(doc, variantId, variant) {
    if (!doc || !variantId) {
      return;
    }

    if (!variant) {
      variant = getPdpVariantById(variantId, doc);
    }

    var form = getRestockVariantForm(doc);
    if (form) {
      if (variant) {
        ensureMasterSelectOption(form, variant);
      } else {
        var idInput = form.querySelector('[name="id"]');
        if (idInput) {
          idInput.value = variantId;
          try {
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          } catch (err) {}
        }
      }
    }

    doc.body.dispatchEvent(
      new CustomEvent('OrdersifyFormChange', {
        detail: { variantID: String(variantId) }
      })
    );
  }

  var BIS_VARIANT_PARAM = 'bis_variant';
  var BIS_VARIANT_SESSION_KEY = 'anap_bis_variant';
  var pendingBisVariantId = null;

  function storePendingBisVariant(variantId) {
    pendingBisVariantId = String(variantId);
    try {
      sessionStorage.setItem(BIS_VARIANT_SESSION_KEY, pendingBisVariantId);
    } catch (err) {}
  }

  function clearPendingBisVariant() {
    pendingBisVariantId = null;
    try {
      sessionStorage.removeItem(BIS_VARIANT_SESSION_KEY);
    } catch (err) {}
  }

  function readPendingBisVariantFromSession() {
    try {
      return sessionStorage.getItem(BIS_VARIANT_SESSION_KEY);
    } catch (err) {
      return null;
    }
  }

  function selectProductVariantOnPdp(variantId) {
    if (!variantId) {
      return false;
    }
    var id = String(variantId);
    var form = getRestockVariantForm(document);
    if (!form) {
      return false;
    }

    var variant = getPdpVariantById(id, document);
    if (variant) {
      // change を発火すると dynamic variants が在庫あり別サイズへ寄せることがあるため、表示同期のみ行う
      setVariantRadiosChecked(variant, document);
      ensureMasterSelectOption(form, variant);
      syncPdpSkuDisplay(variant, document);
      dispatchPdpVariantChange(variant, document);
      return true;
    }

    var hiddenId = form.querySelector('input[name="id"]');
    if (hiddenId) {
      hiddenId.value = id;
      try {
        hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (err) {}
      return true;
    }

    return ensureMasterSelectOption(form, { id: id, title: id });
  }

  function clickOrdersifyInlineButton(productHandle, attempt) {
    var osfBtn = findOrdersifyInlineButton(productHandle);
    if (osfBtn) {
      osfBtn.click();
      return true;
    }
    if (attempt < 24) {
      window.setTimeout(function () {
        clickOrdersifyInlineButton(productHandle, attempt + 1);
      }, 100);
    }
    return false;
  }

  function triggerOrdersifyRestock(variantId, productHandle, onDone) {
    var variant = getPdpVariantById(variantId, document);
    selectProductVariantOnPdp(variantId);
    window.setTimeout(function () {
      selectProductVariantOnPdp(variantId);
      triggerOrdersifyInDocument(document, variantId, variant);
      window.setTimeout(function () {
        triggerOrdersifyInDocument(document, variantId, variant);
        var clicked = clickOrdersifyInlineButton(productHandle || null, 0);
        if (typeof onDone === 'function') {
          onDone(clicked);
        }
      }, 280);
    }, 180);
  }

  function productHandleFromPathOrUrl(pathOrUrl) {
    if (!pathOrUrl) {
      return '';
    }
    try {
      var url =
        String(pathOrUrl).indexOf('http') === 0
          ? new URL(pathOrUrl)
          : new URL(pathOrUrl, window.location.origin);
      var parts = url.pathname.split('/').filter(Boolean);
      var idx = parts.indexOf('products');
      return idx >= 0 && parts[idx + 1] ? parts[idx + 1].split('?')[0] : '';
    } catch (err) {
      var match = String(pathOrUrl).match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    }
  }

  function isCurrentProductPage(productUrl) {
    var handle = productHandleFromPathOrUrl(productUrl);
    if (!handle) {
      return false;
    }
    return productHandleFromPathOrUrl(window.location.pathname) === handle;
  }

  function buildProductBisUrl(productUrl, variantId) {
    try {
      var url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', String(variantId));
      url.searchParams.set(BIS_VARIANT_PARAM, String(variantId));
      return url.pathname + url.search + url.hash;
    } catch (err) {
      var base = String(productUrl || '');
      var sep = base.indexOf('?') >= 0 ? '&' : '?';
      return base + sep + BIS_VARIANT_PARAM + '=' + encodeURIComponent(variantId);
    }
  }

  function closeActiveWishlistModal() {
    var wishlistModal = document.getElementById('WishlistFavoritesModal');
    if (!wishlistModal || !wishlistModal.classList.contains('modal--is-active')) {
      return;
    }
    var closeBtn = wishlistModal.querySelector('.js-modal-close');
    if (closeBtn) {
      closeBtn.click();
    }
  }

  function stripBisDeepLinkParams() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (!params.has(BIS_VARIANT_PARAM)) {
        return;
      }
      params.delete(BIS_VARIANT_PARAM);
      var query = params.toString();
      var nextUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
      window.history.replaceState({}, '', nextUrl);
    } catch (err) {}
  }

  function navigateToProductBis(productUrl, variantId) {
    if (!productUrl || !variantId) {
      return;
    }
    var productHandle = productHandleFromPathOrUrl(productUrl);
    storePendingBisVariant(variantId);
    closeActiveWishlistModal();
    if (isCurrentProductPage(productUrl)) {
      window.setTimeout(function () {
        triggerOrdersifyRestock(variantId, productHandle, function (clicked) {
          if (clicked) {
            clearPendingBisVariant();
          }
        });
      }, 200);
      return;
    }
    window.location.assign(buildProductBisUrl(productUrl, variantId));
  }

  function handleProductBisDeepLink() {
    if (!/\/products\//.test(window.location.pathname)) {
      return;
    }

    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (err) {
      params = null;
    }

    var variantId =
      (params && params.get(BIS_VARIANT_PARAM)) || pendingBisVariantId || readPendingBisVariantFromSession();
    if (!variantId) {
      return;
    }

    pendingBisVariantId = String(variantId);
    if (params && params.get(BIS_VARIANT_PARAM)) {
      stripBisDeepLinkParams();
    }

    var productHandle = productHandleFromPathOrUrl(window.location.pathname);
    var triggered = false;

    function tryTrigger(attempt) {
      if (triggered) {
        return;
      }

      var osfBtn = findOrdersifyInlineButton(null);
      var form = getRestockVariantForm(document);
      if (osfBtn && form) {
        triggered = true;
        triggerOrdersifyRestock(variantId, productHandle, function () {
          clearPendingBisVariant();
        });
        return;
      }

      if (attempt < 80) {
        window.setTimeout(function () {
          tryTrigger(attempt + 1);
        }, 150);
      }
    }

    tryTrigger(0);
  }

  /**
   * SKU / お気に入りモーダル内の再入荷ボタン → Ordersify（.osf_inline_button）を起動する。
   * BIS_trigger は Ordersify 非対応のため、OrdersifyFormChange でバリアントを渡す。
   */
  function bindSkuListModalBisButtonsOnce() {
    if (skuListBisDelegateBound) {
      return;
    }
    skuListBisDelegateBound = true;

    function isRestockButtonContext(node) {
      return (
        node &&
        (node.closest('.modal--sku-list') ||
          node.closest('.modal--wishlist-favorites') ||
          node.closest('[data-wishlist-favorites-root]'))
      );
    }

    document.addEventListener(
      'click',
      function (e) {
        var btn =
          e.target && e.target.closest
            ? e.target.closest('.sku-list-modal__bis, .wishlist-favorites-modal__card-bis')
            : null;
        if (!btn || !isRestockButtonContext(btn)) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) {
          return;
        }

        var productHandle = btn.getAttribute('data-product-handle') || '';
        var isWishlistBis = btn.classList.contains('wishlist-favorites-modal__card-bis');

        if (isWishlistBis) {
          var productUrl = btn.getAttribute('data-product-url') || '';
          if (!productUrl && productHandle) {
            productUrl = '/products/' + encodeURIComponent(productHandle);
          }
          navigateToProductBis(productUrl, variantId);
          return;
        }

        triggerOrdersifyRestock(variantId, productHandle || null);
      },
      true
    );
  }

  function runInitialSkuListSetup() {
    scan(document);
    observeQuickShopHolders();
    bindSkuListModalCartFormsOnce();
    bindSkuListModalBisButtonsOnce();
    handleProductBisDeepLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInitialSkuListSetup, { once: true });
  } else {
    runInitialSkuListSetup();
  }

  window.addEventListener('load', function () {
    handleProductBisDeepLink();
  });

  document.addEventListener('quickview:loaded', function () {
    scan(document);
  });

  document.addEventListener('modalOpen', function () {
    try {
      reparentQuickShopModalEscapeTransform();
    } catch (e) {}
    requestAnimationFrame(function () {
      scan(document);
      var activeSkuModal = document.querySelector('.modal.modal--sku-list.modal--is-active');
      if (activeSkuModal) {
        initSkuListSwymButtons(activeSkuModal);
      }
    });
  });

  document.addEventListener('shopify:section:load', function (evt) {
    var t = evt.target;
    if (t && typeof t.querySelectorAll === 'function') {
      scan(t);
    }
  });
})();

/**
 * 商品: タイトル付近が見えなくなったら variant + カートを画面下部に固定（product-sticky-form）
 */
(function () {
  'use strict';

  function visibilityAllowsDock(visibility) {
    var mq = window.matchMedia('(min-width: 769px)');
    if (visibility === 'mobile') {
      return !mq.matches;
    }
    if (visibility === 'desktop') {
      return mq.matches;
    }
    return true;
  }

  function initProductStickyDock() {
    var form = document.querySelector('[data-sticky-product-form]');
    var sentinel = document.querySelector('[data-sticky-product-sentinel]');
    if (!form || !sentinel || typeof IntersectionObserver !== 'function') {
      return;
    }

    var anchor = form.closest('[data-sticky-product-anchor]');
    var visibility = form.getAttribute('data-sticky-visibility') || 'mobile';
    var docked = false;
    var resizeObserver = null;

    function syncDockPadding() {
      if (!docked) {
        return;
      }
      var h = Math.ceil(form.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--product-sticky-dock-height', h + 'px');
      if (anchor) {
        anchor.style.minHeight = h + 'px';
      }
    }

    function setDocked(active) {
      if (active === docked) {
        return;
      }
      docked = active;
      if (active) {
        form.classList.add('product-sticky-form--fixed-bottom');
        document.body.classList.add('product-sticky-dock-active');
        requestAnimationFrame(function () {
          syncDockPadding();
        });
        if (typeof ResizeObserver === 'function') {
          if (resizeObserver) {
            resizeObserver.disconnect();
          }
          resizeObserver = new ResizeObserver(function () {
            syncDockPadding();
          });
          resizeObserver.observe(form);
        }
      } else {
        form.classList.remove('product-sticky-form--fixed-bottom');
        document.body.classList.remove('product-sticky-dock-active');
        document.documentElement.style.removeProperty('--product-sticky-dock-height');
        if (anchor) {
          anchor.style.minHeight = '';
        }
        if (resizeObserver) {
          resizeObserver.disconnect();
          resizeObserver = null;
        }
      }
    }

    function onIntersect(entries) {
      if (!visibilityAllowsDock(visibility)) {
        setDocked(false);
        return;
      }
      var e = entries[0];
      if (!e) {
        return;
      }
      if (!e.isIntersecting) {
        setDocked(true);
        requestAnimationFrame(syncDockPadding);
      } else {
        setDocked(false);
      }
    }

    var observer = new IntersectionObserver(onIntersect, {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    });
    observer.observe(sentinel);

    function onResizeOrMq() {
      if (!visibilityAllowsDock(visibility)) {
        setDocked(false);
        return;
      }
      if (docked) {
        syncDockPadding();
      }
    }

    window.addEventListener('resize', onResizeOrMq, { passive: true });
    try {
      var mqList = window.matchMedia('(min-width: 769px)');
      if (mqList.addEventListener) {
        mqList.addEventListener('change', onResizeOrMq);
      } else if (mqList.addListener) {
        mqList.addListener(onResizeOrMq);
      }
    } catch (err) {
      /* ignore */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductStickyDock, { once: true });
  } else {
    initProductStickyDock();
  }
})();

/**
 * Sticky バーの「カートに追加」内の価格をバリアント変更に追従（theme.js は [data-add-to-cart-text] のみ更新）
 */
(function () {
  'use strict';

  function syncStickyCartButtonPrice(section, variant) {
    var sticky = section.querySelector('[data-sticky-product-form]');
    if (!sticky) {
      return;
    }
    var priceEl = sticky.querySelector('[data-sticky-cart-button-price]');
    var sep = sticky.querySelector('[data-sticky-cart-button-price-sep]');
    if (!priceEl) {
      return;
    }
    if (!variant || !window.theme || !theme.Currency || !theme.settings) {
      priceEl.textContent = '';
      if (sep) {
        sep.hidden = true;
      }
      return;
    }
    priceEl.textContent = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
    if (sep) {
      sep.hidden = false;
    }
  }

  function bindProductSection(section) {
    if (!section || section.getAttribute('data-sticky-cart-price-bound') === '1') {
      return;
    }
    if (!section.querySelector('[data-sticky-cart-button-price]')) {
      return;
    }
    section.setAttribute('data-sticky-cart-price-bound', '1');
    section.addEventListener('variantChange', function (evt) {
      var v = evt.detail && evt.detail.variant;
      syncStickyCartButtonPrice(section, v);
    });
    section.addEventListener('variantPriceChange', function (evt) {
      var v = evt.detail && evt.detail.variant;
      if (v) {
        syncStickyCartButtonPrice(section, v);
      }
    });
  }

  function scan(root) {
    var el = root || document;
    if (!el.querySelectorAll) {
      return;
    }
    el.querySelectorAll('.product-section').forEach(bindProductSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var t = evt.target;
    if (t && typeof t.querySelectorAll === 'function') {
      scan(t);
    }
  });
})();

/**
 * PDP: Impulse の variant 切替後も「税込」表記を維持（data-product-price の innerHTML 上書き対策）
 */
(function () {
  'use strict';

  var TAX_HTML = '<span class="price-item--tax">税込</span>';

  function bindProductPriceTax(section) {
    if (!section || section.getAttribute('data-anap-price-tax-bound') === '1') {
      return;
    }
    if (!section.querySelector('.product-block--price--anap [data-product-price]')) {
      return;
    }
    section.setAttribute('data-anap-price-tax-bound', '1');
    section.addEventListener('variantPriceChange', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant || typeof theme === 'undefined' || !theme.Currency) {
        return;
      }
      window.setTimeout(function () {
        var priceEl = section.querySelector('[data-product-price]');
        if (!priceEl) {
          return;
        }
        var money = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
        priceEl.innerHTML = money + TAX_HTML;
      }, 0);
    });
  }

  function scan(root) {
    var el = root || document;
    if (!el.querySelectorAll) {
      return;
    }
    el.querySelectorAll('.product-section').forEach(bindProductPriceTax);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var t = evt.target;
    if (t && typeof t.querySelectorAll === 'function') {
      scan(t);
    }
  });
})();

/**
 * Header: トップのオーバーレイをモバイル / PC で切り替え（#SiteHeader data-overlay-*）
 */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 769px)');

  function syncOverlayHeader() {
    if (typeof window.__anapSyncOverlayHeader === 'function') {
      window.__anapSyncOverlayHeader();
    }
  }

  function init() {
    syncOverlayHeader();
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', syncOverlayHeader);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(syncOverlayHeader);
    }
    window.addEventListener('resize', syncOverlayHeader);
    window.addEventListener(
      'scroll',
      function () {
        syncOverlayHeader();
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target && evt.target.querySelector && evt.target.querySelector('#SiteHeader')) {
      syncOverlayHeader();
    }
  });
})();

/**
 * ピル型タブセクション（Featured collections tabs / Blog posts tabs 等）
 * ルート: [data-tabs-root] + data-tabs-config（JSON）
 */
(function () {
  'use strict';

  var PILL_PAD = 3;

  window.ThemeCustom = window.ThemeCustom || {};

  function parseConfig(root) {
    var scriptEl = root.querySelector('script[type="application/json"][data-tabs-config]');
    if (scriptEl && scriptEl.textContent) {
      try {
        return JSON.parse(scriptEl.textContent.trim());
      } catch (e) {}
    }
    var raw = root.getAttribute('data-tabs-config');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function normalizeKey(s) {
    return String(s || '').trim().toLowerCase();
  }

  function parsePrefList(raw) {
    if (!raw) return [];
    return String(raw).split(/[,;]/).map(normalizeKey).filter(Boolean);
  }

  function flickityWatchCssSaysEnable(el) {
    if (!el || typeof window.getComputedStyle !== 'function') return false;
    try {
      var content = window.getComputedStyle(el, ':after').getPropertyValue('content');
      if (!content || content === 'none' || content === 'normal') return false;
      var s = String(content).replace(/^["']|["']$/g, '').trim();
      return s.indexOf('flickity') !== -1;
    } catch (e) {
      return false;
    }
  }

  function initTabsSection(root) {
    if (!root || root.getAttribute('data-tabs-initialized') === 'true') return;

    var cfg = parseConfig(root);
    if (!cfg) return;

    root.setAttribute('data-tabs-initialized', 'true');

    var sectionId = cfg.sectionId;
    var sliderEnabled = !!cfg.sliderEnabled;
    var panelTransitionMs = typeof cfg.panelTransitionMs === 'number' ? cfg.panelTransitionMs : 450;
    var designMode = !!cfg.designMode;
    var prefKey = cfg.prefKey != null ? String(cfg.prefKey) : 'preferredBrand';
    var lastTabKeySetting = cfg.lastTabKey != null ? String(cfg.lastTabKey).trim() : '';
    var lastTabFallback = cfg.lastTabKeyFallback != null ? String(cfg.lastTabKeyFallback) : 'tabsSection:lastTab:';
    var LAST_TAB_KEY = lastTabKeySetting || lastTabFallback;
    var mobileArrowsScrollHide = !!cfg.mobileArrowsScrollHide;
    var aosRefresh = cfg.aosRefresh !== false;

    function getTabs() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-tab-index]'));
    }

    function getPanels() {
      return Array.prototype.slice.call(root.querySelectorAll('.fc-tabs__panel[data-tab-panel-index]'));
    }

    function movePillSlider() {
      var nav = root.querySelector('[data-pill-tabs]');
      if (!nav) return;
      var slider = nav.querySelector('.fc-tabs__pill-slider, .pill-tabs__slider');
      var active = nav.querySelector('.fc-tabs__tab.is-active');
      if (!slider || !active) return;
      slider.style.width = active.offsetWidth + 'px';
      slider.style.transform = 'translateX(' + (active.offsetLeft - PILL_PAD) + 'px)';
    }

    function scheduleAosRefresh() {
      if (!aosRefresh) return;
      function run() {
        try {
          if (window.AOS && typeof window.AOS.refreshHard === 'function') {
            window.AOS.refreshHard();
          }
        } catch (err) {}
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(run);
      });
      setTimeout(run, panelTransitionMs + 100);
    }

    function syncMobileArrowsFirstSlide(flkty, sliderEl) {
      if (!mobileArrowsScrollHide || !flkty || !sliderEl) return;
      if (!root.classList.contains('fc-mobile-arrows--above-scroll-hide')) return;
      sliderEl.classList.toggle('fc-slider-arrows-not-first', flkty.selectedIndex !== 0);
    }

    function bindMobileArrowsFirstSlideOnly(flkty, sliderEl) {
      if (!mobileArrowsScrollHide || !flkty || !sliderEl) return;
      if (!root.classList.contains('fc-mobile-arrows--above-scroll-hide')) return;
      if (!sliderEl._tabsFirstSlideArrowsBound) {
        sliderEl._tabsFirstSlideArrowsBound = true;
        flkty.on('change', function () {
          syncMobileArrowsFirstSlide(flkty, sliderEl);
        });
      }
      syncMobileArrowsFirstSlide(flkty, sliderEl);
    }

    function ensureFlickityOnElement(el, forceReinit) {
      if (!el || !window.Flickity || typeof window.Flickity !== 'function') return null;
      if (!flickityWatchCssSaysEnable(el)) return null;

      var flkty = null;
      try {
        flkty = window.Flickity.data(el);
      } catch (e) {
        flkty = null;
      }

      if (forceReinit && flkty && typeof flkty.destroy === 'function') {
        try {
          el._tabsFirstSlideArrowsBound = false;
          flkty.destroy();
        } catch (e3) {}
        flkty = null;
      }

      if (!flkty) {
        var stale = null;
        try {
          stale = window.Flickity.data(el);
        } catch (e4) {
          stale = null;
        }
        if (stale && typeof stale.destroy === 'function') {
          try {
            el._tabsFirstSlideArrowsBound = false;
            stale.destroy();
          } catch (e5) {}
        }
        var optsText = el.getAttribute('data-tabs-flickity-options') || '{}';
        var opts = {};
        try {
          opts = JSON.parse(optsText);
        } catch (e2) {
          opts = {};
        }
        if (typeof opts.pageDots !== 'boolean') opts.pageDots = false;
        if (typeof opts.prevNextButtons !== 'boolean') opts.prevNextButtons = false;
        if (typeof opts.wrapAround !== 'boolean') opts.wrapAround = false;
        flkty = new window.Flickity(el, opts);
        window.setTimeout(function () {
          scheduleAosRefresh();
        }, 320);
      }

      if (flkty && !el._tabsAosSettleBound) {
        el._tabsAosSettleBound = true;
        flkty.on('settle', function () {
          scheduleAosRefresh();
        });
      }

      bindMobileArrowsFirstSlideOnly(flkty, el);

      if (flkty && typeof flkty.watchCSS === 'function') flkty.watchCSS();
      if (flkty && typeof flkty.resize === 'function') flkty.resize();
      if (flkty && typeof flkty.reposition === 'function') flkty.reposition();
      return flkty;
    }

    function destroyFlickityWhereCssDisabled() {
      if (!sliderEnabled || !window.Flickity || !window.Flickity.data) return;
      var sliders = root.querySelectorAll('[data-tabs-slider]');
      for (var i = 0; i < sliders.length; i++) {
        if (flickityWatchCssSaysEnable(sliders[i])) continue;
        var f = null;
        try {
          f = window.Flickity.data(sliders[i]);
        } catch (e) {
          f = null;
        }
        if (f && typeof f.destroy === 'function') {
          try {
            f.destroy();
          } catch (e2) {}
        }
      }
    }

    function refreshFlickityForActive(forceReinit) {
      if (!sliderEnabled || !window.Flickity || typeof window.Flickity !== 'function') return;
      destroyFlickityWhereCssDisabled();
      var panels = getPanels();
      for (var pi = 0; pi < panels.length; pi++) {
        var sliderEl = panels[pi].querySelector('[data-tabs-slider]');
        if (!sliderEl) continue;
        ensureFlickityOnElement(sliderEl, forceReinit);
      }
    }

    function refreshFlickityForActiveSoon(forceReinit, onDone) {
      if (!sliderEnabled) {
        if (typeof onDone === 'function') onDone();
        return;
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          refreshFlickityForActive(forceReinit);
          if (typeof onDone === 'function') onDone();
        });
      });
    }

    function finishPanelWrapHeightLock(lockPrevH) {
      var wrap = root.querySelector('.fc-tabs__panels-wrap');
      if (!wrap || !lockPrevH) return;
      var panels = getPanels();
      var activePanel = null;
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].classList.contains('is-active')) {
          activePanel = panels[i];
          break;
        }
      }
      var nh = activePanel ? activePanel.offsetHeight : 0;
      if (nh > 0) wrap.style.minHeight = Math.max(lockPrevH, nh) + 'px';
      setTimeout(function () {
        wrap.style.minHeight = '';
      }, panelTransitionMs + 80);
    }

    function pickInitialIndex() {
      var tabs = getTabs();
      var panels = getPanels();
      if (!tabs.length || !panels.length) return 0;
      if (designMode) return 0;

      try {
        var prefRaw = window.localStorage.getItem(prefKey);
        if (prefRaw) {
          var prefs = parsePrefList(prefRaw);
          if (prefs.length) {
            for (var i = 0; i < panels.length; i++) {
              var bk = normalizeKey(panels[i].getAttribute('data-brand-key'));
              if (bk && prefs.indexOf(bk) !== -1) return i;
            }
          }
        }
      } catch (e) {}

      try {
        var last = window.localStorage.getItem(LAST_TAB_KEY);
        var n = parseInt(last, 10);
        if (!isNaN(n) && n >= 0 && n < panels.length) return n;
      } catch (e2) {}

      return 0;
    }

    function setActive(index) {
      var tabs = getTabs();
      var panels = getPanels();
      if (!tabs.length || !panels.length) return;
      if (index < 0 || index >= panels.length) index = 0;

      var prevIndex = -1;
      for (var pi = 0; pi < panels.length; pi++) {
        if (panels[pi].classList.contains('is-active')) {
          prevIndex = pi;
          break;
        }
      }

      if (prevIndex === index && panels[index].classList.contains('is-active')) {
        return;
      }

      var wrap = root.querySelector('.fc-tabs__panels-wrap');
      var lockPrevH = 0;
      if (wrap && prevIndex >= 0 && prevIndex !== index) {
        var curH = wrap.offsetHeight;
        var nextPanel = panels[index];
        var nextH = nextPanel ? nextPanel.offsetHeight : 0;
        lockPrevH = Math.max(curH, nextH);
        if (lockPrevH > 0) wrap.style.minHeight = lockPrevH + 'px';
      }

      for (var t = 0; t < tabs.length; t++) {
        var tabOn = t === index;
        tabs[t].classList.toggle('is-active', tabOn);
        tabs[t].setAttribute('aria-selected', tabOn ? 'true' : 'false');
        tabs[t].setAttribute('tabindex', tabOn ? '0' : '-1');
      }

      for (var p = 0; p < panels.length; p++) {
        panels[p].classList.remove('is-active');
        panels[p].setAttribute('aria-hidden', 'true');
      }
      if (wrap) {
        void wrap.offsetHeight;
      }
      panels[index].classList.add('is-active');
      panels[index].setAttribute('aria-hidden', 'false');

      if (!designMode) {
        try {
          window.localStorage.setItem(LAST_TAB_KEY, String(index));
        } catch (e) {}
      }

      if (lockPrevH > 0) {
        if (sliderEnabled) {
          refreshFlickityForActiveSoon(false, function () {
            requestAnimationFrame(function () {
              finishPanelWrapHeightLock(lockPrevH);
            });
          });
        } else {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              finishPanelWrapHeightLock(lockPrevH);
            });
          });
        }
      } else if (sliderEnabled) {
        refreshFlickityForActiveSoon(false);
      }

      scheduleAosRefresh();
      requestAnimationFrame(movePillSlider);
    }

    function waitForFlickity(attempt) {
      attempt = attempt || 0;
      if (!sliderEnabled) return;
      if (window.Flickity && typeof window.Flickity === 'function') {
        refreshFlickityForActiveSoon();
        return;
      }
      if (attempt >= 80) return;
      setTimeout(function () {
        waitForFlickity(attempt + 1);
      }, 50);
    }

    function bind() {
      var tabs = getTabs();
      for (var b = 0; b < tabs.length; b++) {
        tabs[b].addEventListener('click', (function (btn) {
          return function () {
            var idx = parseInt(btn.getAttribute('data-tab-index'), 10);
            if (isNaN(idx)) return;
            setActive(idx);
          };
        })(tabs[b]));
      }

      var initialIndex = pickInitialIndex();
      setActive(initialIndex);
      scheduleAosRefresh();
      window.addEventListener(
        'load',
        function onTabsLoad() {
          window.removeEventListener('load', onTabsLoad);
          scheduleAosRefresh();
        },
        { once: true }
      );
      requestAnimationFrame(movePillSlider);
      setTimeout(movePillSlider, 100);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          waitForFlickity(0);
        });
      } else {
        waitForFlickity(0);
      }

      window.addEventListener(
        'resize',
        debounce(function () {
          refreshFlickityForActiveSoon(false);
          scheduleAosRefresh();
          movePillSlider();
        }, 150)
      );

      var mq = window.matchMedia('(max-width: 768px)');
      function onBreakpoint() {
        refreshFlickityForActiveSoon(true);
        movePillSlider();
      }
      if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
      else if (mq.addListener) mq.addListener(onBreakpoint);
    }

    bind();

    root._tabsSectionSetActive = setActive;
    root._tabsSectionPickInitial = pickInitialIndex;
    root._tabsSectionMovePill = movePillSlider;
  }

  function scanTabsSections(container) {
    var el = container || document;
    if (!el.querySelectorAll) return;
    el.querySelectorAll('[data-tabs-root]:not([data-tabs-initialized])').forEach(initTabsSection);
  }

  function reinitTabsSectionById(sectionId) {
    var roots = document.querySelectorAll('[data-tabs-root]');
    for (var i = 0; i < roots.length; i++) {
      var cfg = parseConfig(roots[i]);
      if (!cfg || String(cfg.sectionId) !== String(sectionId)) continue;
      roots[i].removeAttribute('data-tabs-initialized');
      initTabsSection(roots[i]);
      if (typeof roots[i]._tabsSectionSetActive === 'function' && typeof roots[i]._tabsSectionPickInitial === 'function') {
        roots[i]._tabsSectionSetActive(roots[i]._tabsSectionPickInitial());
      }
      if (typeof roots[i]._tabsSectionMovePill === 'function') {
        requestAnimationFrame(roots[i]._tabsSectionMovePill);
      }
      break;
    }
  }

  window.ThemeCustom.tabsSection = {
    init: initTabsSection,
    scan: scanTabsSections,
    reinitBySectionId: reinitTabsSectionById,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanTabsSections(document);
    }, { once: true });
  } else {
    scanTabsSections(document);
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var target = evt.target;
    if (target && typeof target.querySelectorAll === 'function') {
      scanTabsSections(target);
    }
  });
})();

/**
 * メニュードロワー先頭: 閲覧履歴（theme.recentlyViewed / theme.buildProductGridItem + Flickity）
 */
(function () {
  'use strict';

  window.ThemeCustom = window.ThemeCustom || {};

  var DEFAULT_LIMIT = 8;
  var inflight = false;
  var lastRenderedKey = '';

  function loadRecentFromStorage() {
    if (!window.theme || !theme.recentlyViewed) {
      return {};
    }
    if (theme.config && theme.config.hasLocalStorage) {
      try {
        var raw = window.localStorage.getItem('theme-recent');
        if (raw) {
          theme.recentlyViewed.recent = JSON.parse(raw);
        }
      } catch (e) {}
    }
    return theme.recentlyViewed.recent || {};
  }

  function getHandles(recent, limit) {
    return Object.keys(recent)
      .filter(function (handle) {
        return handle && handle !== 'undefined';
      })
      .reverse()
      .slice(0, limit);
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('product fetch failed');
        }
        return response.json();
      });
  }

  function prepareProducts(products, recent) {
    var prepared = [];
    var widths = [180, 360, 540, 720];

    products.forEach(function (product) {
      if (!product || !product.handle) {
        return;
      }
      var entry = recent[product.handle] || {};
      product.url = entry.url || product.url;
      if (theme.Images && typeof theme.Images.buildImagePath === 'function') {
        product.image_responsive_url = theme.Images.buildImagePath(product.featured_image);
        product.image_responsive_urls = theme.Images.buildImagePath(product.featured_image, widths);
      }
      if (
        theme.settings &&
        theme.settings.productImageSize === 'natural' &&
        entry.aspectRatio
      ) {
        product.image_aspect_ratio = entry.aspectRatio;
      }
      prepared.push(product);
    });

    return prepared;
  }

  /** コレクション一覧（product-grid-item）と同じ: ベンダー → タイトル（価格なし） */
  function buildGridMarkup(root, products) {
    if (!theme.buildProductImage || !products.length) {
      return '';
    }
    var imageSizes = root.getAttribute('data-image-sizes') || '150px';
    var showVendor = root.getAttribute('data-show-vendor') !== 'false';
    var output = '';

    products.forEach(function (product) {
      var image = theme.buildProductImage(product, imageSizes);
      var vendorMarkup = '';
      var title = product.title || '';
      var tags = product.tags || [];

      if (tags.indexOf('予約商品') >= 0 || tags.indexOf('予約販売複数決済可') >= 0) {
        title = '[予約] ' + title;
      }

      if (showVendor && product.vendor) {
        vendorMarkup = '<div class="grid-product__vendor">' + product.vendor + '</div>';
      }

      output +=
        '<div class="grid__item grid-product" data-product-handle="' +
        product.handle +
        '">' +
        '<div class="grid-product__content">' +
        '<a href="' +
        product.url +
        '" class="grid-product__link">' +
        '<div class="grid__item-image-wrapper">' +
        '<div class="grid-product__image-mask">' +
        image +
        '</div>' +
        '</div>' +
        '<div class="grid-product__meta">' +
        vendorMarkup +
        '<div class="grid-product__title">' +
        title +
        '</div>' +
        '</div>' +
        '</a>' +
        '</div>' +
        '</div>';
    });

    return output;
  }

  /** ドロワー内はスクロール連動の AOS 対象外のため、opacity:0 のまま残さない */
  function stripDrawerHistoryAos(container) {
    if (!container) {
      return;
    }
    container.querySelectorAll('[data-aos]').forEach(function (el) {
      el.removeAttribute('data-aos');
      el.classList.remove('aos-animate');
      el.style.opacity = '1';
      if (el.classList.contains('grid__item')) {
        el.style.removeProperty('transform');
      } else {
        el.style.transform = 'none';
      }
    });
    container.querySelectorAll('.image-wrap .animate-me, .image-wrap svg').forEach(function (el) {
      el.style.opacity = '1';
    });
    container.querySelectorAll('.image-element').forEach(function (el) {
      el.style.opacity = '1';
    });
  }

  function destroySlider(slider) {
    if (!slider || !window.Flickity) {
      return;
    }
    try {
      var flk = window.Flickity.data(slider);
      if (flk && typeof flk.destroy === 'function') {
        flk.destroy();
      }
    } catch (e) {}
  }

  function initSlider(slider) {
    if (!slider || !window.Flickity || typeof window.Flickity !== 'function') {
      return null;
    }
    if (!slider.children.length) {
      return null;
    }
    if (slider.classList.contains('flickity-enabled')) {
      return window.Flickity.data(slider);
    }

    var opts = {};
    try {
      opts = JSON.parse(slider.getAttribute('data-flickity-options') || '{}');
    } catch (e) {
      opts = {};
    }

    var flk;
    try {
      flk = new window.Flickity(slider, opts);
    } catch (e) {
      return null;
    }

    function resize() {
      if (!flk) {
        return;
      }
      if (typeof flk.resize === 'function') {
        flk.resize();
      }
      if (typeof flk.reloadCells === 'function') {
        flk.reloadCells();
      }
    }

    if (window.imagesLoaded) {
      window.imagesLoaded(slider, resize);
    } else {
      slider.querySelectorAll('img').forEach(function (img) {
        if (img.complete) {
          return;
        }
        img.addEventListener('load', resize, { once: true });
        img.addEventListener('error', resize, { once: true });
      });
    }

    return flk;
  }

  function isNavDrawerOpen() {
    return document.documentElement.classList.contains('js-drawer-open');
  }

  function applyCellWidth(root, slider) {
    var pct = parseInt(root.getAttribute('data-cell-width-percent'), 10);
    if (!Number.isFinite(pct) || pct < 1) {
      pct = 35;
    }
    root.style.setProperty('--drawer-history-cell-width', pct + '%');

    if (!slider) {
      return false;
    }

    var trackWidth = slider.getBoundingClientRect().width;
    slider.querySelectorAll('.grid__item').forEach(function (cell) {
      cell.style.paddingLeft = '0';
      cell.style.paddingRight = '8px';
      cell.style.float = 'none';
      cell.style.removeProperty('transform');
      if (trackWidth > 0) {
        cell.style.width = Math.round((trackWidth * pct) / 100) + 'px';
      } else {
        cell.style.width = pct + '%';
      }
    });

    return trackWidth > 0;
  }

  function setVisible(root, visible) {
    if (!root) {
      return;
    }
    if (visible) {
      root.classList.remove('hide');
      root.removeAttribute('hidden');
    } else {
      root.classList.add('hide');
      root.setAttribute('hidden', '');
    }
  }

  function ensureDrawerHistorySlider(root, slider) {
    if (!root || !slider || !slider.children.length) {
      return;
    }

    var ready = applyCellWidth(root, slider);
    var flk = window.Flickity && window.Flickity.data(slider);

    if (!ready) {
      slider.dataset.drawerHistoryFlickityPending = '1';
      return;
    }

    delete slider.dataset.drawerHistoryFlickityPending;

    if (!flk) {
      initSlider(slider);
      flk = window.Flickity && window.Flickity.data(slider);
    }

    if (flk) {
      if (typeof flk.reloadCells === 'function') {
        flk.reloadCells();
      }
      if (typeof flk.resize === 'function') {
        flk.resize();
      }
      if (typeof flk.updatePrevNextButtons === 'function') {
        flk.updatePrevNextButtons();
      }
      requestAnimationFrame(function () {
        if (typeof flk.resize === 'function') {
          flk.resize();
        }
        if (typeof flk.updatePrevNextButtons === 'function') {
          flk.updatePrevNextButtons();
        }
      });
    }
  }

  function renderDrawerBrowsingHistory() {
    var root = document.querySelector('[data-drawer-browsing-history]');
    if (!root || inflight) {
      return;
    }

    var slider = root.querySelector('[data-drawer-browsing-history-slider]');
    if (!slider) {
      return;
    }

    var limit = parseInt(root.getAttribute('data-limit'), 10);
    if (!Number.isFinite(limit) || limit < 1) {
      limit = DEFAULT_LIMIT;
    }

    var recent = loadRecentFromStorage();
    var handles = getHandles(recent, limit);

    var handlesKey = handles.join('|');

    if (!handles.length) {
      if (lastRenderedKey || slider.children.length) {
        destroySlider(slider);
        slider.innerHTML = '';
        lastRenderedKey = '';
      }
      setVisible(root, false);
      return;
    }

    if (handlesKey === lastRenderedKey && slider.querySelector('.grid__item')) {
      setVisible(root, true);
      if (isNavDrawerOpen()) {
        ensureDrawerHistorySlider(root, slider);
      }
      return;
    }

    if (inflight) {
      return;
    }

    inflight = true;

    Promise.all(handles.map(fetchProduct))
      .then(function (products) {
        var valid = prepareProducts(products.filter(Boolean), recent);

        if (!valid.length) {
          destroySlider(slider);
          slider.innerHTML = '';
          lastRenderedKey = '';
          setVisible(root, false);
          return;
        }

        var nextKey = valid
          .map(function (p) {
            return p.handle;
          })
          .join('|');

        if (nextKey === lastRenderedKey && slider.querySelector('.grid__item')) {
          setVisible(root, true);
          if (isNavDrawerOpen()) {
            ensureDrawerHistorySlider(root, slider);
          }
          return;
        }

        destroySlider(slider);
        slider.innerHTML = buildGridMarkup(root, valid);
        stripDrawerHistoryAos(slider);
        lastRenderedKey = nextKey;
        setVisible(root, true);
        if (isNavDrawerOpen()) {
          ensureDrawerHistorySlider(root, slider);
        } else {
          slider.dataset.drawerHistoryFlickityPending = '1';
        }
        if (window.AOS && typeof window.AOS.refreshHard === 'function') {
          window.AOS.refreshHard();
        }
      })
      .catch(function () {
        destroySlider(slider);
        slider.innerHTML = '';
        lastRenderedKey = '';
        setVisible(root, false);
      })
      .finally(function () {
        inflight = false;
      });
  }

  function initDrawerBrowsingHistory() {
    if (!document.querySelector('[data-drawer-browsing-history]')) {
      return;
    }
    renderDrawerBrowsingHistory();
    document.addEventListener('drawerOpen.NavDrawer', function () {
      var root = document.querySelector('[data-drawer-browsing-history]');
      var slider = root && root.querySelector('[data-drawer-browsing-history-slider]');
      if (!root || !slider) {
        return;
      }
      renderDrawerBrowsingHistory();
      requestAnimationFrame(function () {
        ensureDrawerHistorySlider(root, slider);
      });
    });
  }

  window.ThemeCustom.drawerBrowsingHistory = {
    render: renderDrawerBrowsingHistory,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerBrowsingHistory, { once: true });
  } else {
    initDrawerBrowsingHistory();
  }
})();

/**
 * カート「お買い物を続ける」: 同一セッションで最後に見たコレクションへ誘導
 * （テーマエディタでリンク先URLが未設定のときのみ上書き）
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'anap-last-collection-url';

  function isValidCollectionUrl(url) {
    if (!url || typeof url !== 'string') {
      return false;
    }
    try {
      var parsed = url.indexOf('://') === -1 ? new URL(url, window.location.origin) : new URL(url);
      if (parsed.origin !== window.location.origin) {
        return false;
      }
      return parsed.pathname.indexOf('/collections/') === 0;
    } catch (e) {
      return false;
    }
  }

  function saveLastCollection(url) {
    if (!window.sessionStorage || !isValidCollectionUrl(url)) {
      return;
    }
    try {
      sessionStorage.setItem(STORAGE_KEY, url);
    } catch (e) {
      /* private mode / quota */
    }
  }

  function getLastCollection() {
    if (!window.sessionStorage) {
      return null;
    }
    try {
      var stored = sessionStorage.getItem(STORAGE_KEY);
      return isValidCollectionUrl(stored) ? stored : null;
    } catch (e) {
      return null;
    }
  }

  function collectionPathFromProductUrl(pathname) {
    var match = pathname.match(/^(\/collections\/[^/]+)/);
    return match ? match[1] : null;
  }

  function persistLastCollectionFromPage() {
    var body = document.body;
    if (!body) {
      return;
    }

    if (body.classList.contains('template-collection')) {
      saveLastCollection(window.location.pathname + window.location.search);
      return;
    }

    if (!body.classList.contains('template-product')) {
      return;
    }

    var fromProductPath = collectionPathFromProductUrl(window.location.pathname);
    if (fromProductPath) {
      saveLastCollection(fromProductPath + window.location.search);
      return;
    }

    if (document.referrer) {
      try {
        var ref = new URL(document.referrer, window.location.origin);
        if (ref.origin === window.location.origin && ref.pathname.indexOf('/collections/') === 0) {
          saveLastCollection(ref.pathname + ref.search);
          return;
        }
      } catch (e) {
        /* invalid referrer */
      }
    }

    var fallback = body.getAttribute('data-last-collection-url');
    if (fallback) {
      saveLastCollection(fallback);
    }
  }

  function applyCartContinueLinks() {
    if (!document.body || !document.body.classList.contains('template-cart')) {
      return;
    }

    var last = getLastCollection();
    if (!last) {
      return;
    }

    document.querySelectorAll('[data-cart-continue-dynamic]').forEach(function (link) {
      link.setAttribute('href', last);
    });
  }

  function initLastCollectionContinue() {
    persistLastCollectionFromPage();
    applyCartContinueLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLastCollectionContinue, { once: true });
  } else {
    initLastCollectionContinue();
  }
})();

/**
 * Header search: portal overlay to body so it covers announcement bar (theme.js unchanged).
 * Watches `.site-header__search-container.is-active` (added after predictive-search:open).
 */
(function initHeaderSearchOverlay() {
  'use strict';

  var portalState = {
    container: null,
    containerParent: null,
    containerNext: null,
    screen: null,
    screenParent: null,
    screenNext: null
  };

  function getSearchContainer() {
    return document.querySelector('.site-header__search-container');
  }

  function getHeaderPredictiveSearch() {
    return (
      document.querySelector('predictive-search[data-context="header"]') ||
      document.querySelector('.site-header__search predictive-search')
    );
  }

  function getHeaderBarElement() {
    return (
      document.getElementById('SiteHeader') ||
      document.querySelector('.header-sticky-wrapper') ||
      document.getElementById('HeaderWrapper')
    );
  }

  function cleanupSearchUi() {
    document.body.classList.remove('predictive-overflow-hidden');
    var ps = getHeaderPredictiveSearch();
    if (ps) ps.classList.remove('is-active');
  }

  function closeSearch() {
    cleanupSearchUi();
    document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
  }

  function positionSearchBar() {
    var container = portalState.container || getSearchContainer();
    var headerEl = getHeaderBarElement();
    if (!container || !headerEl) return;

    var rect = headerEl.getBoundingClientRect();
    container.style.setProperty('--anap-search-top', Math.max(0, Math.round(rect.top)) + 'px');
    container.style.setProperty('--anap-search-bar-height', Math.max(0, Math.round(rect.height)) + 'px');
  }

  function openSearchOverlay() {
    var container = getSearchContainer();
    var ps = getHeaderPredictiveSearch();
    if (!container || !ps || container.classList.contains('anap-search-overlay--portaled')) return;

    portalState.container = container;
    if (!portalState.containerParent) {
      portalState.containerParent = container.parentNode;
      portalState.containerNext = container.nextElementSibling;
    }

    var screen = ps.querySelector('[data-screen]');
    if (screen && screen.parentNode !== container) {
      portalState.screen = screen;
      portalState.screenParent = screen.parentNode;
      portalState.screenNext = screen.nextElementSibling;
      container.insertBefore(screen, container.firstChild);
    }

    document.body.appendChild(container);
    container.classList.add('anap-search-overlay--portaled');
    requestAnimationFrame(positionSearchBar);
  }

  function restoreSearchOverlay() {
    var container = portalState.container || getSearchContainer();
    if (!container || !container.classList.contains('anap-search-overlay--portaled')) return;

    if (portalState.screen && portalState.screenParent) {
      if (portalState.screenNext && portalState.screenNext.parentNode === portalState.screenParent) {
        portalState.screenParent.insertBefore(portalState.screen, portalState.screenNext);
      } else {
        portalState.screenParent.appendChild(portalState.screen);
      }
    }

    container.classList.remove('anap-search-overlay--portaled');
    container.style.removeProperty('--anap-search-top');
    container.style.removeProperty('--anap-search-bar-height');

    if (portalState.containerParent) {
      if (portalState.containerNext && portalState.containerNext.parentNode === portalState.containerParent) {
        portalState.containerParent.insertBefore(container, portalState.containerNext);
      } else {
        portalState.containerParent.appendChild(container);
      }
    }

    portalState = {
      container: null,
      containerParent: null,
      containerNext: null,
      screen: null,
      screenParent: null,
      screenNext: null
    };
  }

  function onContainerClassChange(container) {
    if (container.classList.contains('is-active')) {
      openSearchOverlay();
      return;
    }
    restoreSearchOverlay();
    cleanupSearchUi();
  }

  function watchSearchContainer() {
    var container = getSearchContainer();
    if (!container || container._anapOverlayObserver) return;

    var observer = new MutationObserver(function () {
      onContainerClassChange(container);
    });
    observer.observe(container, { attributes: true, attributeFilter: ['class'] });
    container._anapOverlayObserver = observer;

    if (container.classList.contains('is-active')) {
      openSearchOverlay();
    }
  }

  function fixStuckSearchState() {
    var container = getSearchContainer();
    if (!container) return;
    if (!container.classList.contains('is-active')) {
      restoreSearchOverlay();
      cleanupSearchUi();
    }
  }

  if (!document.documentElement._anapSearchCloseDelegation) {
    document.documentElement._anapSearchCloseDelegation = true;

    document.addEventListener('click', function (evt) {
      var container = getSearchContainer();
      if (!container || !container.classList.contains('anap-search-overlay--portaled')) return;

      var ps = getHeaderPredictiveSearch();
      if (!ps || ps.getAttribute('data-enabled') !== 'false') return;

      var target = evt.target;
      if (target.closest && target.closest('.predictive__screen')) {
        closeSearch();
        return;
      }
      if (target.closest && target.closest('.btn--close-search')) {
        evt.preventDefault();
        closeSearch();
      }
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.keyCode !== 27) return;
      var container = getSearchContainer();
      if (!container || !container.classList.contains('anap-search-overlay--portaled')) return;
      var ps = getHeaderPredictiveSearch();
      if (!ps || ps.getAttribute('data-enabled') !== 'false') return;
      closeSearch();
    });
  }

  document.addEventListener('predictive-search:close-all', function () {
    restoreSearchOverlay();
    cleanupSearchUi();
  });

  window.addEventListener('resize', function () {
    if (document.querySelector('.site-header__search-container.anap-search-overlay--portaled')) {
      positionSearchBar();
    }
  });

  function boot() {
    watchSearchContainer();
    fixStuckSearchState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

/**
 * LEEEP 複数埋め込み時、各 tag が差し込む <style> を #leeep-embedded-{tagId} 配下に閉じ込める。
 * 未対応だと .LeeepFollowButton 等のスタイルが最後に読み込んだ tag の設定で全 widget に上書きされる。
 */
(function () {
  'use strict';

  var boundTagIds = {};

  function findMatchingBrace(css, openIdx) {
    var depth = 0;
    for (var i = openIdx; i < css.length; i++) {
      if (css.charAt(i) === '{') {
        depth++;
      } else if (css.charAt(i) === '}') {
        depth--;
        if (depth === 0) {
          return i;
        }
      }
    }
    return css.length - 1;
  }

  function prefixLeeepSelectors(selectors, prefix) {
    return selectors
      .split(',')
      .map(function (sel) {
        sel = sel.trim();
        if (!sel || sel.indexOf('leeep-embedded-') !== -1 || sel.charAt(0) === '@') {
          return sel;
        }
        return prefix + sel;
      })
      .join(', ');
  }

  function scopeLeeepCssString(css, prefix) {
    var out = '';
    var i = 0;

    while (i < css.length) {
      var nextAt = css.indexOf('@', i);
      var nextBrace = css.indexOf('{', i);

      if (nextBrace === -1) {
        out += css.slice(i);
        break;
      }

      if (nextAt !== -1 && nextAt < nextBrace) {
        var ruleEnd = findMatchingBrace(css, nextBrace);
        var header = css.slice(nextAt, nextBrace);
        var inner = css.slice(nextBrace + 1, ruleEnd);

        if (header.indexOf('@media') === 0 || header.indexOf('@supports') === 0) {
          out += header + '{' + scopeLeeepCssString(inner, prefix) + '}';
        } else {
          out += css.slice(nextAt, ruleEnd + 1);
        }

        i = ruleEnd + 1;
        continue;
      }

      var selectors = css.slice(i, nextBrace).trim();
      var bodyEnd = findMatchingBrace(css, nextBrace);
      var body = css.slice(nextBrace + 1, bodyEnd);

      if (selectors.charAt(0) === '@') {
        out += css.slice(i, bodyEnd + 1);
      } else {
        out += prefixLeeepSelectors(selectors, prefix) + '{' + body + '}';
      }

      i = bodyEnd + 1;
    }

    return out;
  }

  function scopeLeeepStyleElement(styleEl, tagId) {
    if (!styleEl || styleEl.getAttribute('data-leeep-scoped') === tagId) {
      return;
    }

    var css = styleEl.textContent || '';
    if (!css.trim()) {
      return;
    }

    var prefix = '#leeep-embedded-' + tagId + ' ';
    styleEl.textContent = scopeLeeepCssString(css, prefix);
    styleEl.setAttribute('data-leeep-scoped', tagId);
  }

  function scopeLeeepStylesInRoot(root, tagId) {
    if (!root) {
      return;
    }

    root.querySelectorAll('style').forEach(function (styleEl) {
      scopeLeeepStyleElement(styleEl, tagId);
    });
  }

  function bindLeeepEmbedScope(tagId) {
    if (!tagId || boundTagIds[tagId] === true || boundTagIds[tagId] === 'watching') {
      return;
    }

    var embeddedId = 'leeep-embedded-' + tagId;
    var embedded = document.getElementById(embeddedId);

    function bindRoot(root) {
      if (!root || root.getAttribute('data-leeep-scope-bound') === '1') {
        return;
      }

      root.setAttribute('data-leeep-scope-bound', '1');
      scopeLeeepStylesInRoot(root, tagId);

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) {
              return;
            }

            if (node.tagName === 'STYLE') {
              scopeLeeepStyleElement(node, tagId);
              return;
            }

            if (typeof node.querySelectorAll === 'function') {
              node.querySelectorAll('style').forEach(function (styleEl) {
                scopeLeeepStyleElement(styleEl, tagId);
              });
            }
          });
        });
      });

      observer.observe(root, { childList: true, subtree: true });
    }

    if (embedded) {
      bindRoot(embedded);
      boundTagIds[tagId] = true;
      return;
    }

    var mount = document.getElementById('leeep-tag-' + tagId);
    if (!mount) {
      return;
    }

    boundTagIds[tagId] = 'watching';

    var mountObserver = new MutationObserver(function () {
      var nextEmbedded = document.getElementById(embeddedId);
      if (!nextEmbedded) {
        return;
      }
      bindRoot(nextEmbedded);
      boundTagIds[tagId] = true;
      mountObserver.disconnect();
    });

    mountObserver.observe(mount, { childList: true, subtree: true });
  }

  function collectLeeepTagIds() {
    var ids = [];
    var seen = {};

    document.querySelectorAll('[id^="leeep-tag-"]').forEach(function (el) {
      var match = el.id.match(/^leeep-tag-(\d+)$/);
      if (!match || seen[match[1]]) {
        return;
      }
      seen[match[1]] = true;
      ids.push(match[1]);
    });

    document.querySelectorAll('[data-leeep-tag-id]').forEach(function (el) {
      var tagId = el.getAttribute('data-leeep-tag-id');
      if (!tagId || seen[tagId]) {
        return;
      }
      seen[tagId] = true;
      ids.push(tagId);
    });

    return ids;
  }

  function bootLeeepStyleScoping() {
    collectLeeepTagIds().forEach(bindLeeepEmbedScope);

    if (document.body.getAttribute('data-leeep-scope-watch') === '1') {
      return;
    }

    document.body.setAttribute('data-leeep-scope-watch', '1');

    var bodyObserver = new MutationObserver(function () {
      collectLeeepTagIds().forEach(bindLeeepEmbedScope);
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLeeepStyleScoping, { once: true });
  } else {
    bootLeeepStyleScoping();
  }

  document.addEventListener('shopify:section:load', bootLeeepStyleScoping);
})();

/**
 * お気に入りモーダル（Swym fetch + 自前UI + LEEEP フォロー）
 */
(function () {
  'use strict';

  var MODAL_ID = 'WishlistFavoritesModal';
  var leeepScriptPromise = null;
  var wishlistModalInstance = null;
  var wishlistCartLock = false;
  var wishlistModalOpenHandlerBound = false;
  var wishlistInteractionsBound = false;
  var wishlistResizeBound = false;

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      var fmt =
        (theme.settings && theme.settings.moneyFormat) ||
        theme.moneyFormat ||
        '${{amount}}';
      return theme.Currency.formatMoney(cents, fmt);
    }
    var n = Number(cents || 0) / 100;
    return '¥' + n.toLocaleString('ja-JP');
  }

  function handleFromProductUrl(du) {
    if (!du) {
      return '';
    }
    try {
      var url =
        du.indexOf('http') === 0
          ? new URL(du)
          : new URL(du, window.location.origin);
      var parts = url.pathname.split('/').filter(Boolean);
      var idx = parts.indexOf('products');
      return idx >= 0 && parts[idx + 1] ? parts[idx + 1].split('?')[0] : '';
    } catch (e) {
      var m = String(du).match(/\/products\/([^/?#]+)/);
      return m ? m[1] : '';
    }
  }

  function getModalRoot() {
    return document.querySelector('[data-wishlist-favorites-modal-root]');
  }

  function findWishlistRoot(node) {
    if (!node || typeof node.closest !== 'function') {
      return null;
    }
    return node.closest('[data-wishlist-favorites-root]');
  }

  function bumpWishlistLoadToken(root) {
    var token = parseInt(root.getAttribute('data-wishlist-load-token') || '0', 10) + 1;
    root.setAttribute('data-wishlist-load-token', String(token));
    return token;
  }

  function isWishlistGridExpanded(root) {
    return root && root.getAttribute('data-wishlist-grid-expanded') === '1';
  }

  function setWishlistGridExpanded(root, expanded) {
    if (!root) {
      return;
    }
    root.setAttribute('data-wishlist-grid-expanded', expanded ? '1' : '0');
  }

  function withSwat(callback) {
    if (typeof callback !== 'function') {
      return;
    }
    if (window._swat) {
      callback(window._swat);
      return;
    }

    var called = false;
    var wrapped = function (swat) {
      if (called) {
        return;
      }
      called = true;
      callback(swat);
    };

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(wrapped);

    setTimeout(function () {
      if (!called && window._swat) {
        wrapped(window._swat);
      }
    }, 300);
  }

  function setStatus(root, state) {
    var loading = root.querySelector('[data-wishlist-loading]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var error = root.querySelector('[data-wishlist-error]');
    var panel = root.querySelector('[data-wishlist-products-panel]');
    var viewAllWrap = root.querySelector('[data-wishlist-view-all-wrap]');

    if (loading) {
      loading.hidden = state !== 'loading';
    }
    if (empty) {
      empty.hidden = state !== 'empty';
    }
    if (error) {
      error.hidden = state !== 'error';
    }
    if (panel) {
      panel.hidden = state !== 'list';
    }
    if (viewAllWrap && state !== 'list') {
      viewAllWrap.hidden = true;
    }
  }

  function getWishlistGridLimit(list) {
    if (!list) {
      return 0;
    }

    var style = window.getComputedStyle(list);
    var isDesktop = window.matchMedia('(min-width: 769px)').matches;
    var cols = parseInt(
      style.getPropertyValue(isDesktop ? '--wishlist-cols-desktop' : '--wishlist-cols-mobile'),
      10
    );
    var rows = parseInt(
      style.getPropertyValue(isDesktop ? '--wishlist-rows-desktop' : '--wishlist-rows-mobile'),
      10
    );

    if (!cols || cols < 1) {
      cols = isDesktop ? 4 : 2;
    }
    if (!rows || rows < 1) {
      rows = 2;
    }

    return cols * rows;
  }

  function applyWishlistGridCollapse(root) {
    var list = root.querySelector('[data-wishlist-list]');
    var viewAllWrap = root.querySelector('[data-wishlist-view-all-wrap]');
    if (!list) {
      return;
    }

    var cards = list.querySelectorAll('[data-wishlist-item]');
    var limit = getWishlistGridLimit(list);
    var shouldCollapse = !isWishlistGridExpanded(root) && cards.length > limit;

    Array.prototype.forEach.call(cards, function (card, index) {
      card.classList.toggle('wishlist-favorites-modal__card--collapsed', shouldCollapse && index >= limit);
    });

    if (viewAllWrap) {
      viewAllWrap.hidden = !shouldCollapse;
    }
  }

  function bindWishlistGridResize() {
    if (wishlistResizeBound) {
      return;
    }
    wishlistResizeBound = true;

    window.addEventListener('resize', function () {
      window.clearTimeout(bindWishlistGridResize._timer);
      bindWishlistGridResize._timer = window.setTimeout(function () {
        document.querySelectorAll('[data-wishlist-favorites-root]').forEach(function (root) {
          if (!isWishlistGridExpanded(root)) {
            applyWishlistGridCollapse(root);
          }
        });
      }, 150);
    });
  }

  function findVariant(product, epi) {
    if (!product || !product.variants || !product.variants.length) {
      return null;
    }
    var target = String(epi);
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === target) {
        return product.variants[i];
      }
    }
    return product.variants[0];
  }

  function variantLabel(variant) {
    if (!variant) {
      return '';
    }
    return [variant.option1, variant.option2, variant.option3]
      .filter(function (v) {
        return v && v !== 'Default Title';
      })
      .join(' / ');
  }

  function fetchProductByHandle(handle) {
    if (!handle) {
      return Promise.reject(new Error('missing handle'));
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('product unavailable');
      }
      return response.json();
    });
  }

  function productHasUnlistedTag(product) {
    var tags = product && product.tags;
    if (!tags) {
      return false;
    }
    if (typeof tags === 'string') {
      tags = tags.split(',');
    }
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim() === '_unlisted') {
        return true;
      }
    }
    return false;
  }

  function normalizeWishlistItems(raw) {
    if (!raw) {
      return [];
    }
    if (Array.isArray(raw)) {
      return raw;
    }
    if (Array.isArray(raw.listcontents)) {
      return raw.listcontents;
    }
    if (Array.isArray(raw.items)) {
      return raw.items;
    }
    return [];
  }

  function buildWishlistTitle(product, fallbackTitle) {
    var title = (product && product.title) || fallbackTitle || '';
    var tags = (product && product.tags) || [];

    if (tags.indexOf('予約商品') >= 0 || tags.indexOf('予約販売複数決済可') >= 0) {
      title = '[予約] ' + title;
    }

    return title;
  }

  function buildWishlistImageMarkup(imageUrl, title) {
    if (!imageUrl) {
      return '<div class="product-image--placeholder" aria-hidden="true"></div>';
    }

    return (
      '<img class="grid-product__image image-style--square" src="' +
      escapeHtml(imageUrl) +
      '" alt="' +
      escapeHtml(title) +
      '" loading="lazy" width="540" height="675">'
    );
  }

  function buildWishlistPriceMarkup(variant, product, fallbackCents) {
    var cents =
      (variant && variant.price) ||
      (product && product.price) ||
      fallbackCents ||
      0;
    var compare = variant && variant.compare_at_price;
    var html = '<div class="grid-product__price grid-product__price--anap">';

    if (compare && compare > cents) {
      html +=
        '<span class="grid-product__price--sale">' +
        escapeHtml(formatMoney(cents)) +
        '<span class="grid-product__price-tax">税込</span></span>' +
        '<s class="grid-product__price--original">' +
        escapeHtml(formatMoney(compare)) +
        '</s>';
    } else {
      html +=
        '<span class="grid-product__price-current">' +
        escapeHtml(formatMoney(cents)) +
        '<span class="grid-product__price-tax">税込</span></span>';
    }

    html += '</div>';
    return html;
  }

  function buildItemMarkup(item, product, variant) {
    var title = buildWishlistTitle(product, item.dt);
    var url = (product && product.url) || item.du || '#';
    var image =
      (variant && variant.featured_image && variant.featured_image.src) ||
      (product && product.featured_image) ||
      item.iu ||
      '';
    var label = variantLabel(variant);
    var isActive = !!product;
    var isAvailable = !!(variant && variant.available);
    var showVendor =
      window.theme &&
      theme.settings &&
      theme.settings.vendorEnable &&
      product &&
      product.vendor;
    var statusText = '';

    if (!isActive) {
      statusText = '取り扱い終了';
    }

    var actionBtn = '';
    if (isActive && isAvailable) {
      actionBtn =
        '<button type="button" class="btn btn--full add-to-cart wishlist-favorites-modal__card-action wishlist-favorites-modal__card-add" data-wishlist-add-to-cart data-variant-id="' +
        escapeHtml(variant.id) +
        '"><span data-add-to-cart-text>カートに追加</span></button>';
    } else if (isActive && !isAvailable && variant && variant.id) {
      actionBtn =
        '<button type="button" class="btn btn--secondary btn--small wishlist-favorites-modal__card-action wishlist-favorites-modal__card-bis" data-variant-id="' +
        escapeHtml(variant.id) +
        '" data-product-handle="' +
        escapeHtml(product.handle) +
        '" data-product-url="' +
        escapeHtml(url) +
        '">再入荷お知らせ</button>';
    }

    return (
      '<div class="grid__item grid-product wishlist-favorites-modal__card' +
      (isActive && !isAvailable ? ' soldout' : '') +
      '" data-wishlist-item data-epi="' +
      escapeHtml(item.epi) +
      '" data-empi="' +
      escapeHtml(item.empi) +
      '" data-du="' +
      escapeHtml(item.du || url) +
      '">' +
      '<div class="grid-product__content">' +
      '<button type="button" class="wishlist-favorites-modal__card-remove js-wishlist-favorites-remove" aria-label="お気に入りから削除">' +
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>' +
      '</button>' +
      '<a href="' +
      escapeHtml(url) +
      '" class="grid-product__link">' +
      '<div class="grid__item-image-wrapper">' +
      '<div class="grid-product__image-mask">' +
      buildWishlistImageMarkup(image, title) +
      '</div>' +
      '</div>' +
      '<div class="grid-product__meta">' +
      (showVendor
        ? '<div class="grid-product__vendor">' + escapeHtml(product.vendor) + '</div>'
        : '') +
      '<div class="grid-product__title">' +
      escapeHtml(title) +
      '</div>' +
      (label
        ? '<p class="wishlist-favorites-modal__card-variant">' + escapeHtml(label) + '</p>'
        : '') +
      buildWishlistPriceMarkup(variant, product, item.pr) +
      (statusText
        ? '<p class="wishlist-favorites-modal__card-status is-inactive">' + escapeHtml(statusText) + '</p>'
        : '') +
      '</div>' +
      '</a>' +
      actionBtn +
      '</div>' +
      '</div>'
    );
  }

  function stripWishlistGridAos(container) {
    if (!container) {
      return;
    }

    container.querySelectorAll('[data-aos]').forEach(function (el) {
      el.removeAttribute('data-aos');
      el.classList.remove('aos-animate');
      el.style.opacity = '1';
      el.style.removeProperty('transform');
    });

    container.querySelectorAll('.image-wrap .animate-me, .image-wrap svg, .image-element').forEach(function (el) {
      el.style.opacity = '1';
    });
  }

  function renderWishlistItems(root, items) {
    var list = root.querySelector('[data-wishlist-list]');
    if (!list) {
      return;
    }

    if (!items.length) {
      list.innerHTML = '';
      setStatus(root, 'empty');
      return;
    }

    var jobs = items.map(function (item) {
      var handle = handleFromProductUrl(item.du);
      return fetchProductByHandle(handle)
        .then(function (product) {
          if (productHasUnlistedTag(product)) {
            return '';
          }
          var variant = findVariant(product, item.epi);
          return buildItemMarkup(item, product, variant);
        })
        .catch(function () {
          return buildItemMarkup(item, null, null);
        });
    });

    Promise.all(jobs)
      .then(function (rows) {
        rows = rows.filter(function (html) {
          return html !== '';
        });
        if (!rows.length) {
          list.innerHTML = '';
          setStatus(root, 'empty');
          return;
        }
        list.innerHTML = rows.join('');
        stripWishlistGridAos(list);
        setWishlistGridExpanded(root, false);
        setStatus(root, 'list');
        applyWishlistGridCollapse(root);
      })
      .catch(function () {
        setStatus(root, 'error');
      });
  }

  function fetchWishlistViaLists(swat, onSuccess, onError) {
    if (!swat || typeof swat.fetchLists !== 'function') {
      onError();
      return;
    }

    swat.fetchLists({
      callbackFn: function (lists) {
        var items = [];
        (lists || []).forEach(function (list) {
          if (list && list.listcontents) {
            items = items.concat(list.listcontents);
          }
        });
        onSuccess(items);
      },
      errorFn: onError
    });
  }

  function loadWishlistProducts(root) {
    if (!root) {
      return;
    }

    var token = bumpWishlistLoadToken(root);
    setStatus(root, 'loading');

    var settled = false;
    var timeoutId = setTimeout(function () {
      if (token !== parseInt(root.getAttribute('data-wishlist-load-token') || '0', 10) || settled) {
        return;
      }
      settled = true;
      setStatus(root, 'error');
    }, 12000);

    function isCurrentToken() {
      return token === parseInt(root.getAttribute('data-wishlist-load-token') || '0', 10);
    }

    function finish(items) {
      if (!isCurrentToken() || settled) {
        return;
      }
      settled = true;
      clearTimeout(timeoutId);
      renderWishlistItems(root, normalizeWishlistItems(items));
    }

    function fail() {
      if (!isCurrentToken() || settled) {
        return;
      }
      settled = true;
      clearTimeout(timeoutId);
      setStatus(root, 'error');
    }

    withSwat(function (swat) {
      if (!isCurrentToken()) {
        return;
      }

      if (!swat) {
        fail();
        return;
      }

      if (typeof swat.fetch === 'function') {
        try {
          swat.fetch(function (products) {
            finish(products);
          });
          return;
        } catch (e) {}
      }

      fetchWishlistViaLists(swat, finish, fail);
    });
  }

  function removeWishlistItem(root, itemEl, swat) {
    if (!itemEl || !swat || typeof swat.removeFromWishList !== 'function') {
      return;
    }

    var product = {
      epi: Number(itemEl.getAttribute('data-epi')),
      empi: Number(itemEl.getAttribute('data-empi')),
      du: itemEl.getAttribute('data-du') || ''
    };

    itemEl.setAttribute('aria-busy', 'true');

    swat.removeFromWishList(
      product,
      function () {
        itemEl.remove();
        var list = root.querySelector('[data-wishlist-list]');
        if (list && !list.querySelector('[data-wishlist-item]')) {
          setStatus(root, 'empty');
          return;
        }
        applyWishlistGridCollapse(root);
      },
      function () {
        itemEl.removeAttribute('aria-busy');
      }
    );
  }

  function addToCart(variantId, btn) {
    if (!variantId || wishlistCartLock || !window.theme || !theme.routes || !theme.routes.cartAdd) {
      return;
    }

    wishlistCartLock = true;
    if (btn) {
      btn.classList.add('btn--loading');
      btn.disabled = true;
    }

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        if (res.status === 422) {
          return;
        }

        if (document.body.classList.contains('template-cart')) {
          window.scrollTo(0, 0);
          window.location.reload();
          return;
        }

        if (theme.settings && theme.settings.cartType === 'page') {
          window.location = theme.routes.cartPage;
          return;
        }

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: res,
              addToCartBtn: btn
            },
            bubbles: true
          })
        );
      })
      .catch(function () {})
      .finally(function () {
        wishlistCartLock = false;
        if (btn) {
          btn.classList.remove('btn--loading');
          btn.disabled = false;
        }
      });
  }

  function bindWishlistInteractions() {
    if (wishlistInteractionsBound) {
      return;
    }
    wishlistInteractionsBound = true;

    document.addEventListener('click', function (e) {
      var activeRoot = findWishlistRoot(e.target);
      if (!activeRoot) {
        return;
      }

      var removeBtn = e.target.closest('.js-wishlist-favorites-remove');
      if (removeBtn) {
        e.preventDefault();
        var itemEl = removeBtn.closest('[data-wishlist-item]');
        withSwat(function (swat) {
          removeWishlistItem(activeRoot, itemEl, swat);
        });
        return;
      }

      var addBtn = e.target.closest('[data-wishlist-add-to-cart]');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(addBtn.getAttribute('data-variant-id'), addBtn);
        return;
      }

      var viewAllBtn = e.target.closest('[data-wishlist-view-all]');
      if (viewAllBtn) {
        e.preventDefault();
        setWishlistGridExpanded(activeRoot, true);
        applyWishlistGridCollapse(activeRoot);
      }
    });
  }

  function initAccountWishlistBlock(root) {
    if (!root || root.getAttribute('data-wishlist-account-initialized') === '1') {
      return;
    }

    root.setAttribute('data-wishlist-account-initialized', '1');
    setWishlistGridExpanded(root, false);
    loadWishlistProducts(root);
    initLeeepMounts(root);
  }

  function initAccountWishlistBlocks() {
    document.querySelectorAll('[data-wishlist-account-block]').forEach(initAccountWishlistBlock);
  }

  function ensureLeeepScript() {
    if (window.LeeepCite) {
      return Promise.resolve();
    }
    if (leeepScriptPromise) {
      return leeepScriptPromise;
    }

    leeepScriptPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src*="cite.leeep.jp/v2/embed/js"]');
      if (existing) {
        if (window.LeeepCite) {
          resolve();
          return;
        }
        existing.addEventListener('load', function () {
          resolve();
        });
        existing.addEventListener('error', reject);
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://cite.leeep.jp/v2/embed/js';
      script.defer = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return leeepScriptPromise;
  }

  function prepareLeeepUid() {
    var cite = window.LeeepCite;
    if (!cite) {
      return Promise.resolve(false);
    }

    if (typeof cite.ensureParteTracking === 'function') {
      cite.ensureParteTracking();
    }

    if (typeof cite.waitForParteTrackingBid === 'function') {
      return cite.waitForParteTrackingBid(5000).then(function (bid) {
        if (bid) {
          cite.uid = String(bid);
          return true;
        }
        return false;
      });
    }

    return Promise.resolve(!!cite.uid);
  }

  function resetLeeepTagState(mount, tagId) {
    var cite = window.LeeepCite;
    var container = mount.querySelector('[data-leeep-container]');
    if (!container) {
      return;
    }

    container.innerHTML = '';

    if (cite && typeof cite.embeddedElemId === 'function') {
      var embeddedId = cite.embeddedElemId(tagId);
      var embedded = document.getElementById(embeddedId);
      if (embedded && mount.contains(embedded)) {
        embedded.remove();
      }
      if (Array.isArray(cite.initingTagIds)) {
        cite.initingTagIds = cite.initingTagIds.filter(function (id) {
          return id !== tagId;
        });
      }
    }
  }

  function setLeeepStaffEmptyState(mount, visible) {
    var emptyEl = mount.querySelector('[data-wishlist-leeep-staff-empty]');
    if (emptyEl) {
      emptyEl.hidden = !visible;
    }
  }

  function waitForLeeepContainer() {
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          setTimeout(resolve, 80);
        });
      });
    });
  }

  function refreshLeeepMountHeight(mount) {
    var iframe = mount.querySelector('iframe.leeep-tag-iframe, iframe[id^="leeep-tag-iframe-"]');
    if (!iframe || !iframe.contentWindow) {
      return;
    }

    try {
      iframe.contentWindow.postMessage({ requestDocumentHeight: true }, '*');
    } catch (e) {}

    setTimeout(function () {
      try {
        iframe.contentWindow.postMessage({ requestDocumentHeight: true }, '*');
      } catch (err) {}
    }, 400);
  }

  function mountHasLeeepContent(mount) {
    var container = mount.querySelector('[data-leeep-container]');
    if (!container) {
      return false;
    }

    return !!container.querySelector(
      '[id^="leeep-embedded-"], iframe.leeep-tag-iframe, iframe[id^="leeep-tag-iframe-"], .LeeepList, .LeeepStaffList'
    );
  }

  function initLeeepWishlistMount(mount, hasUid) {
    var cite = window.LeeepCite;
    var tagId = mount.getAttribute('data-leeep-tag-id');
    var container = mount.querySelector('[data-leeep-container]');
    var isStaffMount = mount.getAttribute('data-leeep-mount-kind') === 'staff';

    if (!cite || !tagId || !container) {
      return Promise.resolve();
    }

    if (isStaffMount) {
      setLeeepStaffEmptyState(mount, false);
    }

    return waitForLeeepContainer()
      .then(function () {
        if (mountHasLeeepContent(mount)) {
          refreshLeeepMountHeight(mount);
          return;
        }

        resetLeeepTagState(mount, tagId);

        return cite
          .initByTagId(tagId, { tag_id: tagId })
          .then(function () {
            mount.setAttribute('data-leeep-initialized', '1');
            refreshLeeepMountHeight(mount);

            if (isStaffMount) {
              setTimeout(function () {
                if (!mountHasLeeepContent(mount)) {
                  setLeeepStaffEmptyState(mount, true);
                }
              }, 1200);
            }
          });
      })
      .catch(function () {
        mount.removeAttribute('data-leeep-initialized');
        if (isStaffMount && !hasUid) {
          setLeeepStaffEmptyState(mount, true);
        }
      });
  }

  function initLeeepMounts(root) {
    var mounts = root.querySelectorAll('[data-leeep-mount][data-leeep-tag-id]');
    if (!mounts.length) {
      return;
    }

    ensureLeeepScript()
      .then(function () {
        return prepareLeeepUid();
      })
      .then(function (hasUid) {
        var tasks = [];

        Array.prototype.forEach.call(mounts, function (mount) {
          var tagId = mount.getAttribute('data-leeep-tag-id');
          if (!tagId) {
            return;
          }

          if (!hasUid && mount.getAttribute('data-leeep-mount-kind') === 'staff') {
            setLeeepStaffEmptyState(mount, true);
            return;
          }

          tasks.push(initLeeepWishlistMount(mount, hasUid));
        });

        return Promise.all(tasks);
      })
      .catch(function () {});
  }

  function initWishlistFavoritesModal() {
    var root = getModalRoot();
    if (!root || !document.getElementById(MODAL_ID) || !window.theme || !theme.Modals) {
      return;
    }

    if (!wishlistModalInstance) {
      try {
        wishlistModalInstance = new theme.Modals(MODAL_ID, 'wishlist-favorites', {
          closeOffContentClick: true
        });
      } catch (e) {
        return;
      }
    }

    if (!wishlistModalOpenHandlerBound) {
      wishlistModalOpenHandlerBound = true;
      document.addEventListener('modalOpen.' + MODAL_ID, function () {
        var activeRoot = getModalRoot();
        if (!activeRoot) {
          return;
        }
        setWishlistGridExpanded(activeRoot, false);
        loadWishlistProducts(activeRoot);
        initLeeepMounts(activeRoot);
      });
    }
  }

  function bootWishlistFavorites() {
    ensureLeeepScript()
      .then(function () {
        if (window.LeeepCite && typeof window.LeeepCite.ensureParteTracking === 'function') {
          window.LeeepCite.ensureParteTracking();
        }
      })
      .catch(function () {});
    bindWishlistInteractions();
    bindWishlistGridResize();
    initWishlistFavoritesModal();
    initAccountWishlistBlocks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWishlistFavorites, { once: true });
  } else {
    bootWishlistFavorites();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var target = evt.target;
    if (!target || typeof target.querySelector !== 'function') {
      return;
    }
    if (target.querySelector('[data-wishlist-favorites-modal-root]')) {
      wishlistModalInstance = null;
      bootWishlistFavorites();
    }
    if (target.querySelector('[data-wishlist-account-block]')) {
      initAccountWishlistBlocks();
    }
  });
})();

/**
 * Helium Customer Fields: 郵便番号 → 住所自動入力（フォーム VKtN0r）
 * CF app embed の「Enable developer tools」が ON であること。
 */
(function initCustomerFieldsZipAutofill() {
  'use strict';

  var CF_FORM_ID = 'VKtN0r';
  var ZIP_COLUMN = 'default_address.zip';
  var PROVINCE_COLUMN = 'default_address.province';
  var CITY_COLUMN = 'default_address.city';
  var ADDRESS1_COLUMN = 'default_address.address1';
  var ZIP_API = 'https://zipcloud.ibsnet.co.jp/api/search?zipcode=';

  var lastFetchedZip = '';
  var isAutoFilling = false;

  function normalizeZip(value) {
    return String(value || '').replace(/[^\d]/g, '');
  }

  function getTargetForm() {
    return document.querySelector('form[data-cf-form="' + CF_FORM_ID + '"]');
  }

  function getFieldContainer(form, columnKey) {
    if (!form) {
      return null;
    }
    return (
      form.querySelector('.cf-field[data-cf-column-key="' + columnKey + '"]') ||
      form.querySelector('[data-cf-column-key="' + columnKey + '"]')
    );
  }

  function removeTownPicker(form) {
    if (!form) {
      return;
    }
    var existing = form.querySelector('[data-cf-zip-town-picker]');
    if (existing) {
      existing.remove();
    }
  }

  function uniqueTowns(results) {
    var towns = [];
    results.forEach(function (row) {
      var town = row.address3 || '';
      if (town && towns.indexOf(town) === -1) {
        towns.push(town);
      }
    });
    return towns;
  }

  function showTownPicker(form, cfForm, towns) {
    removeTownPicker(form);
    if (!towns || towns.length <= 1) {
      return;
    }

    var addressField = getFieldContainer(form, ADDRESS1_COLUMN);
    if (!addressField || !addressField.parentNode) {
      return;
    }

    var wrap = document.createElement('div');
    wrap.setAttribute('data-cf-zip-town-picker', '1');
    wrap.style.marginTop = '8px';

    var label = document.createElement('label');
    label.textContent = '町域を選択';
    label.style.display = 'block';
    label.style.marginBottom = '4px';
    label.style.fontSize = '0.875rem';

    var select = document.createElement('select');
    select.className = 'cf-zip-town-picker__select';
    select.setAttribute('aria-label', '町域を選択');

    towns.forEach(function (town) {
      var option = document.createElement('option');
      option.value = town;
      option.textContent = town;
      select.appendChild(option);
    });

    select.addEventListener('change', function () {
      isAutoFilling = true;
      try {
        cfForm.setFieldValue(ADDRESS1_COLUMN, select.value);
      } finally {
        isAutoFilling = false;
      }
    });

    wrap.appendChild(label);
    wrap.appendChild(select);
    addressField.parentNode.insertBefore(wrap, addressField.nextSibling);
  }

  function applyAddress(form, results) {
    if (!form || !form.cfForm || !results || !results.length) {
      return;
    }

    var cfForm = form.cfForm;
    var first = results[0];
    var towns = uniqueTowns(results);

    isAutoFilling = true;
    try {
      cfForm.setFieldValue(PROVINCE_COLUMN, first.address1 || '');
      cfForm.setFieldValue(CITY_COLUMN, first.address2 || '');
      cfForm.setFieldValue(ADDRESS1_COLUMN, towns[0] || '');
    } finally {
      isAutoFilling = false;
    }

    if (towns.length > 1) {
      showTownPicker(form, cfForm, towns);
    } else {
      removeTownPicker(form);
    }
  }

  function fetchAddress(form, zip) {
    if (!form || zip === lastFetchedZip) {
      return;
    }

    lastFetchedZip = zip;

    fetch(ZIP_API + encodeURIComponent(zip))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!data || data.status !== 200 || !data.results || !data.results.length) {
          lastFetchedZip = '';
          removeTownPicker(form);
          return;
        }
        applyAddress(form, data.results);
      })
      .catch(function () {
        lastFetchedZip = '';
      });
  }

  function onFieldChanged(event) {
    if (isAutoFilling || !event || !event.detail) {
      return;
    }
    if (event.detail.columnKey !== ZIP_COLUMN) {
      return;
    }

    var form =
      event.target && event.target.closest
        ? event.target.closest('form[data-cf-form]')
        : null;
    if (!form || form.getAttribute('data-cf-form') !== CF_FORM_ID) {
      return;
    }

    var zip = normalizeZip(event.detail.value);
    if (zip.length < 7) {
      lastFetchedZip = '';
      removeTownPicker(form);
      return;
    }
    if (zip.length !== 7) {
      return;
    }

    fetchAddress(form, zip);
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-cf-zip-bound') === '1') {
      return;
    }
    form.setAttribute('data-cf-zip-bound', '1');
    form.addEventListener('cf:field_changed', onFieldChanged);
  }

  function init() {
    var form = getTargetForm();
    if (form && form.cfForm) {
      bindForm(form);
    }
  }

  function boot() {
    if (window.CF && typeof window.CF.ready === 'function') {
      window.CF.ready(init);
      return;
    }
    document.addEventListener('cf:ready', init, { once: true });
  }

  boot();
  document.addEventListener('cf:ready', init);
})();

(function () {
  function relocateCollectionHeader() {
    var mount = document.querySelector('[data-collection-header-mount]');
    if (!mount) return;

    mount.replaceChildren();

    document.querySelectorAll('.shopify-section.collection-header-section-host--empty').forEach(function (host) {
      host.classList.remove('collection-header-section-host--empty');
    });

    var headerSection = document.querySelector(
      '.collection-header-section[data-header-layout="content_column"]'
    );
    if (!headerSection) return;

    var source = headerSection.querySelector('[data-collection-header-relocate]');
    if (!source) return;

    mount.appendChild(source);

    var host = headerSection.closest('.shopify-section');
    if (host) host.classList.add('collection-header-section-host--empty');
  }

  document.addEventListener('DOMContentLoaded', relocateCollectionHeader);
  document.addEventListener('shopify:section:unload', function (evt) {
    if (!evt || !evt.target) return;
    if (evt.target.querySelector('[data-collection-header-relocate]')) {
      var mount = document.querySelector('[data-collection-header-mount]');
      if (mount) mount.replaceChildren();
    }
  });
  document.addEventListener('shopify:section:load', function (evt) {
    if (
      evt &&
      evt.target &&
      evt.target.querySelector &&
      (evt.target.querySelector('[data-collection-header-relocate]') ||
        evt.target.querySelector('[data-collection-header-mount]'))
    ) {
      relocateCollectionHeader();
    }
  });
})();

/**
 * @version 1.1.0
 * @updated 2026-10-01
 * コレクション価格フィルター: スライダー代わりの固定レンジ帯
 *
 * Changelog:
 * - 1.1.0: 価格帯切替時に旧 min/max が URL に残る不具合を修正（getUpdatedParams）
 * - 1.0.0: data-price-band 選択を filter.v.price の min/max に反映
 */
(function () {
  'use strict';

  if (!window.theme || !theme.Collection || !theme.Collection.prototype) {
    return;
  }

  function applyPriceBandSelection(input) {
    var form = input.closest('form');
    if (!form) {
      return;
    }

    var minInput = form.querySelector('[data-price-range-min]');
    var maxInput = form.querySelector('[data-price-range-max]');
    if (!minInput || !maxInput) {
      return;
    }

    var bands = form.querySelectorAll('[data-price-band]');
    Array.prototype.forEach.call(bands, function (band) {
      if (band !== input) {
        band.checked = false;
        var bandItem = band.closest('li');
        if (bandItem) {
          bandItem.classList.remove('tag--active');
        }
      }
    });

    if (input.checked) {
      minInput.value = input.getAttribute('data-min') || '';
      maxInput.value = input.getAttribute('data-max') || '';
    } else {
      minInput.value = '';
      maxInput.value = '';
    }
  }

  function formDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    formData.forEach(function (value, key) {
      if (value !== '' && value != null) {
        searchParams.append(key, value);
      }
    });
    return searchParams;
  }

  var originalOnFormSubmit = theme.Collection.prototype.onFormSubmit;
  theme.Collection.prototype.onFormSubmit = function (evt) {
    var el = evt && evt.target;
    if (el && el.hasAttribute && el.hasAttribute('data-price-band')) {
      applyPriceBandSelection(el);
    }
    return originalOnFormSubmit.call(this, evt);
  };

  theme.Collection.prototype.renderFromFormData = function (formData) {
    this.renderCollectionPage(formDataToSearchParams(formData));
  };

  /**
   * Impulse 標準の getUpdatedParams は clone.entries() 中に delete するため、
   * 隣接する filter.v.price.gte / lte の一方が消え残ることがある。
   * 削除キーを先に集めてから消す。
   */
  if (theme.AjaxRenderer && theme.AjaxRenderer.prototype) {
    theme.AjaxRenderer.prototype.getUpdatedParams = function (currentParams, newParams) {
      var clone = new URLSearchParams(currentParams);
      var preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];
      var keysToDelete = [];
      var seenDelete = {};

      clone.forEach(function (value, key) {
        if (preservedParams.indexOf(key) !== -1) {
          return;
        }
        if (newParams.getAll(key).indexOf(value) === -1 && !seenDelete[key]) {
          seenDelete[key] = true;
          keysToDelete.push(key);
        }
      });

      keysToDelete.forEach(function (key) {
        clone.delete(key);
      });

      newParams.forEach(function (value, key) {
        if (value !== '' && clone.getAll(key).indexOf(value) === -1) {
          clone.append(key, value);
        }
      });

      return clone;
    };
  }
})();
